const translations = {
  tr: {
    // Navigation
    nav: {
      home: 'Ana Sayfa',
      services: 'Hizmetler',
      blog: 'Blog',
      academy: 'Akademi',
      about: 'Hakkımızda',
      contact: 'İletişim',
      references: 'Referanslar',
      career: 'Kariyer',
      glossary: 'Sözlük',
      education: 'Eğitimler',
      consulting: 'Saatlik Danışmanlık',
    },
    // Services
    services: {
      googleAds: 'Google Reklamcılığı',
      metaAds: 'Meta Reklamcılığı',
      socialMedia: 'Sosyal Medya Yönetimi',
      webDesign: 'Web Sitesi Tasarımı',
      seoGeo: 'SEO & GEO',
      appDevelopment: 'Uygulama Geliştirme',
      marketplace: 'Pazar Yeri Danışmanlığı',
      shopify: 'Shopify E-Ticaret',
      ugcInfluencer: 'UGC & Influencer Marketing',
      mentorship: 'Mentörlük',
      marketingTools: 'Hesaplama Araçları',
    },
    // Common
    common: {
      getStarted: 'Get started',
      scheduleDemo: 'Schedule a demo',
      learnMore: 'Daha Fazla Bilgi',
      contactUs: 'İletişime Geçin',
      readMore: 'Devamını Oku',
      faq: 'Sıkça Sorulan Sorular',
    },
    // Footer
    footer: {
      description: 'Dijital pazarlama ve performans reklamcılığı konusunda uzman ekibimizle işletmenizi bir sonraki seviyeye taşıyın.',
      quickLinks: 'Hızlı Bağlantılar',
      services: 'Hizmetlerimiz',
      contact: 'İletişim',
      address: 'Zeytinlik Mah. Fişekhane Cad. Carousel No: 5 İç Kapı No: 17 Bakırköy/İstanbul',
      workingHours: 'Çalışma Saatleri',
      weekdays: 'Pazartesi - Cuma: 09:00 - 18:00',
      weekend: 'Cumartesi - Pazar: Kapalı',
      rights: 'Tüm hakları saklıdır.',
    },
    // Contact
    contact: {
      title: 'İletişim',
      subtitle: 'Bizimle iletişime geçin',
      description: 'Dijital pazarlama hedeflerinizi gerçekleştirmek için bizimle iletişime geçin. Uzman ekibimiz size en uygun çözümü sunmaya hazır.',
      quoteFormTitle: 'Teklif Talep Formu',
      quoteFormDescription: 'Size en uygun çözümü sunabilmemiz için lütfen aşağıdaki formu doldurun.',
      name: 'Ad Soyad',
      namePlaceholder: 'Adınız ve soyadınız',
      email: 'E-posta',
      emailPlaceholder: 'ornek@email.com',
      phone: 'Telefon',
      phonePlaceholder: '+90 (5xx) xxx xx xx',
      company: 'Şirket',
      companyPlaceholder: 'Şirket adınız',
      service: 'İlgilendiğiniz Hizmet',
      selectService: 'Hizmet seçin',
      budget: 'Bütçe Aralığı',
      selectBudget: 'Bütçe seçin',
      message: 'Mesajınız',
      messagePlaceholder: 'Projeniz hakkında detaylı bilgi verin...',
      send: 'Mesaj Gönder',
      sending: 'Gönderiliyor...',
      successTitle: 'Teşekkürler!',
      successMessage: 'Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.',
      ourOffice: 'Ofisimiz',
      openMap: 'Haritada Aç',
      address: 'Zeytinlik Mah. Fişekhane Cad. Carousel No: 5 İç Kapı No: 17',
      city: 'Bakırköy/İstanbul',
      faq: 'Sık Sorulan Sorular',
      faq1Question: 'Ne kadar sürede sonuç alırım?',
      faq1Answer: 'SEO çalışmaları 3-6 ay, Google Ads kampanyaları 1-2 hafta içinde sonuç vermeye başlar.',
      faq2Question: 'Hangi sektörlerle çalışıyorsunuz?',
      faq2Answer: 'E-ticaret, teknoloji, sağlık, eğitim, finans gibi tüm sektörlerle çalışıyoruz.',
      faq3Question: 'Raporlama nasıl yapılıyor?',
      faq3Answer: 'Aylık detaylı performans raporları ve haftalık özet raporlar sunuyoruz.',
      contactInfo: {
        email: {
          title: 'E-posta',
          details: 'info@thinklyze.com',
          description: '24 saat içinde yanıtlıyoruz',
        },
        phone: {
          title: 'Telefon',
          details: '0553 657 64 54',
          description: 'Pazartesi - Cuma, 09:00 - 18:00',
        },
        address: {
          title: 'Adres',
          details: 'Zeytinlik Mah. Fişekhane Cad. Carousel No: 5 İç Kapı No: 17',
          description: 'Bakırköy/İstanbul',
        },
        hours: {
          title: 'Çalışma Saatleri',
          details: 'Pazartesi - Cuma: 09:00 - 18:00',
          description: 'Hafta içi hizmetinizdeyiz',
        },
      },
      services: [
        'SEO Optimizasyonu',
        'Google Ads Yönetimi',
        'Social Media Marketing',
        'İçerik Pazarlama',
        'Dijital Pazarlama Danışmanlığı',
        'Web Analitik',
        'Diğer',
      ],
      budgetRanges: [
        '5.000₺ - 10.000₺',
        '10.000₺ - 25.000₺',
        '25.000₺ - 50.000₺',
        '50.000₺ - 100.000₺',
        '100.000₺+',
      ],
      formLabels: {
        name: 'Ad Soyad',
        email: 'E-posta',
        phone: 'Telefon',
        company: 'Şirket',
        service: 'İlgilendiğiniz Hizmet',
        budget: 'Bütçe Aralığı',
        message: 'Mesajınız',
      },
      notSpecified: 'Belirtilmemiş',
      quoteRequestForm: 'Teklif Talep Formu',
    },
    // Live Support
    liveSupport: {
      title: 'Canlı Destek',
      placeholder: 'Mesajınızı yazın',
      welcome: 'Merhaba! Thinklyze\'a hoş geldiniz! 👋',
      help: 'Size nasıl yardımcı olabilirim? Sorularınızı WhatsApp üzerinden yanıtlayabilirim.',
      responseTime: 'Genellikle birkaç dakika içinde yanıt verir',
      continueWhatsApp: 'WhatsApp\'ta Devam Et',
      secure: 'Güvenli ve hızlı iletişim',
      placeholderText: 'Mesajınızı yazın...',
    },
    // Callback Modal
    callback: {
      title: 'Size nasıl ulaşırım?',
      name: 'Ad Soyad',
      namePlaceholder: 'Adınız ve Soyadınız',
      email: 'Email',
      emailPlaceholder: 'Email Adresiniz',
      phone: 'Telefon',
      phonePlaceholder: 'Telefon Numaranız',
      company: 'Şirket Adı',
      companyPlaceholder: 'Şirket Adı',
      ecommerce: 'E-ticaret yapıyor musunuz?',
      yes: 'Evet',
      no: 'Hayır',
      starting: 'Yeni Başlıyorum',
      source: 'Thinklyze\'ı nereden duydunuz?',
      customer: 'Thinklyze Müşterilerinden',
      callMe: 'Sizi Arayalım',
    },
    // Service Descriptions
    serviceDescriptions: {
      googleAds: 'Google Ads ve YouTube kampanyaları',
      metaAds: 'Facebook ve Instagram reklamları',
      socialMedia: 'Topluluk oluşturma ve içerik yönetimi',
      webDesign: 'Modern ve responsive web tasarımları',
      seoGeo: 'Arama motoru ve lokal SEO optimizasyonu',
      appDevelopment: 'iOS, Android ve web uygulamaları',
      marketplace: 'Trendyol, Amazon ve daha fazlası',
      shopify: 'E-ticaret mağazaları ve optimizasyon',
      ugcInfluencer: 'Kullanıcı üretimi içerikler ve influencer işbirlikleri',
      mentorship: 'Dijital pazarlama mentörlüğü ve danışmanlık',
      marketingTools: 'ROAS, ROI, CPM ve daha fazla pazarlama metrikleri',
    },
    // Service Pages
    servicePages: {
      common: {
        scheduleMeeting: 'Toplantı Planlayalım',
        callMe: 'Sizi Arayalım',
        trustedBy: 'Hızlı büyüyen markalar Thinklyze\'a güveniyor.',
        getStarted: 'Başlayın',
        keyBenefits: 'Temel Avantajlar',
        additionalFeatures: 'Ek Özellikler',
        serviceScope: 'Hizmet Kapsamımız:',
      },
      ugcInfluencer: {
        tag: 'UGC & Influencer Marketing',
        title: 'UGC & Influencer Marketing',
        description: 'Kullanıcı üretimi içerikler ve influencer işbirlikleri ile marka bilinirliğinizi artırın, hedef kitlenize ulaşın ve satışlarınızı yükseltin.',
        features: [
          {
            title: 'UGC İçerik Üretimi',
            description: 'Gerçek kullanıcılar tarafından üretilen otantik içerikler ile markanıza güven kazandırın'
          },
          {
            title: 'Influencer İşbirlikleri',
            description: 'Hedef kitlenize uygun influencer\'lar ile stratejik işbirlikleri kurun'
          },
          {
            title: 'Hedef Kitle Analizi',
            description: 'Doğru influencer ve içerik üreticilerini bulmak için detaylı analiz yapın'
          },
          {
            title: 'Kampanya Yönetimi',
            description: 'Tüm influencer kampanyalarınızı tek platformdan yönetin ve takip edin'
          },
          {
            title: 'Marka Uyumu',
            description: 'Marka değerlerinize uygun içerik ve influencer seçimleri yapın'
          },
          {
            title: 'Performans Analizi',
            description: 'Kampanya performansını ölçün ve ROI\'yi maksimize edin'
          }
        ],
        services: [
          'UGC İçerik Üretimi ve Yönetimi',
          'Mikro ve Makro Influencer İşbirlikleri',
          'Influencer Seçimi ve Analizi',
          'İçerik Stratejisi Geliştirme',
          'Kampanya Planlama ve Yönetimi',
          'Performans Takibi ve Raporlama',
          'Marka Ambassador Programları',
          'Ürün Lansman Kampanyaları',
          'Hashtag Kampanyaları',
          'İçerik Hakları ve Yasal Uyum'
        ],
        mockupCard: {
          title: 'Influencer Kampanyası',
          subtitle: 'UGC & İçerik Pazarlama',
          heading: 'Marka Bilinirliği Kampanyası',
          description: 'Otantik kullanıcı üretimi içerik ve influencer işbirlikleri ile hedef kitlenize ulaşın.',
          metrics: {
            influencers: '50+ Influencer',
            content: '100+ UGC İçerik',
            reach: '5M+ Erişim',
            engagement: '500K+ Etkileşim'
          },
          stats: {
            roi: 'ROI',
            projects: 'Proje',
            support: 'Destek'
          }
        },
        keyBenefits: {
          title: 'UGC & Influencer Marketing ile markanızı nasıl büyütürüz',
          subtitle: 'Otantik içerikler ve stratejik influencer işbirlikleri ile marka bilinirliğinizi artırın ve hedef kitlenize güvenilir şekilde ulaşın.',
          benefits: [
            {
              title: 'Otantik İçerik Üretimi',
              description: 'Gerçek kullanıcılar tarafından üretilen otantik içerikler ile markanıza güven kazandırın. UGC kampanyaları ile sosyal kanıt oluşturun ve dönüşümlerinizi artırın.'
            },
            {
              title: 'Stratejik Influencer İşbirlikleri',
              description: 'Hedef kitlenize uygun mikro ve makro influencer\'lar ile stratejik işbirlikleri kurun. Doğru influencer seçimi ve kampanya yönetimi ile maksimum etki yaratın.'
            },
            {
              title: 'Ölçülebilir Sonuçlar',
              description: 'Tüm kampanyalarınızı detaylı analiz ve raporlama ile takip edin. ROI, erişim, etkileşim ve dönüşüm metrikleri ile performansınızı sürekli optimize edin.'
            }
          ]
        },
        additionalFeatures: {
          title: 'Kapsamlı çözümler sunuyoruz',
          subtitle: 'UGC ve Influencer Marketing\'in tüm yönlerini kapsayan profesyonel hizmetlerimiz ile markanızı büyütün.'
        },
        faq: {
          title: 'Sıkça Sorulan Sorular',
          subtitle: 'UGC & Influencer Marketing hakkında en çok merak edilen sorular',
          items: [
            {
              question: 'UGC (User Generated Content) nedir?',
              answer: 'UGC, markaların müşterileri tarafından üretilen otantik içeriklerdir. Bu içerikler markanız için güçlü sosyal kanıt oluşturur ve potansiyel müşterilerinize daha güvenilir görünmenizi sağlar.'
            },
            {
              question: 'Influencer seçimi nasıl yapılır?',
              answer: 'Hedef kitleniz, influencer\'ın takipçi kalitesi, engagement oranları, içerik kalitesi ve marka uyumu gibi faktörler dikkate alınarak profesyonel analiz yapılır. Size en uygun influencer\'lar seçilir.'
            },
            {
              question: 'Bir influencer kampanyası ne kadar sürer?',
              answer: 'Kampanya süresi, hedeflerinize ve bütçenize göre değişir. Genellikle 1-3 aylık kampanyalar önerilir, ancak kısa süreli kampanyalar da düzenlenebilir.'
            },
            {
              question: 'ROI nasıl ölçülür?',
              answer: 'Erişim, etkileşim, website trafiği, dönüşüm ve satış metrikleri ile kampanya performansı detaylı şekilde takip edilir ve aylık raporlar sunulur.'
            },
            {
              question: 'UGC içeriklerinin hakları kimdedir?',
              answer: 'İçerik hakları kampanya şartlarına göre belirlenir. Genellikle markanın kullanım hakkı alınır ve yasal uyumluluk sağlanır.'
            }
          ]
        }
      },
      googleAds: {
        tag: 'Google Ads',
        title: 'Google Ads Yönetimi',
        description: 'Google\'ın gücünü markanız için kullanın. Hedefli reklamlarla doğru müşterilere ulaşın ve satışlarınızı artırın.',
        features: [
          { title: 'Hedefli Kampanyalar', description: 'Doğru kitleye, doğru zamanda, doğru mesajla ulaşın' },
          { title: 'ROI Optimizasyonu', description: 'Her tıklama için maksimum geri dönüş sağlayın' },
          { title: 'Detaylı Analiz', description: 'Kampanya performansını gerçek zamanlı takip edin' },
          { title: 'Kitle Segmentasyonu', description: 'Demografik ve davranışsal hedefleme ile etkili erişim' },
          { title: 'Hızlı Sonuçlar', description: '24 saat içinde ilk sonuçları görmeye başlayın' },
          { title: 'Güvenli Yönetim', description: 'Google Partner sertifikalı uzmanlarla güvenli kampanya yönetimi' }
        ],
        services: [
          'Google Ads Kampanya Kurulumu',
          'Anahtar Kelime Araştırması ve Analizi',
          'Reklam Metni Yazımı ve Optimizasyonu',
          'Teklif Stratejisi Yönetimi',
          'Dönüşüm Takibi Kurulumu',
          'A/B Test Yönetimi',
          'Negatif Kelime Optimizasyonu',
          'Kalite Puanı Artırma',
          'Rekabet Analizi',
          'Aylık Performans Raporları'
        ],
        campaignTypes: [
          { title: 'Arama Kampanyaları', description: 'Google\'da arama yapan kullanıcılara text reklamlar gösterin', benefits: ['Yüksek niyet', 'Hızlı dönüşüm', 'Ölçülebilir sonuçlar'] },
          { title: 'Display Kampanyaları', description: 'Milyonlarca web sitesinde görsel reklamlarınızı gösterin', benefits: ['Geniş erişim', 'Marka bilinirliği', 'Remarketing imkanı'] },
          { title: 'Shopping Kampanyaları', description: 'E-ticaret ürünlerinizi Google\'da öne çıkarın', benefits: ['Ürün görseli', 'Fiyat bilgisi', 'Doğrudan satış'] },
          { title: 'YouTube Kampanyaları', description: 'Video reklamlarla YouTube\'da hedef kitlenize ulaşın', benefits: ['Görsel etki', 'Geniş kitle', 'Marka hikayesi'] }
        ],
        stats: [
          { number: '300%', label: 'Ortalama ROI Artışı' },
          { number: '48 Saat', label: 'Kampanya Kurulum Süresi' },
          { number: '50+', label: 'Başarılı Proje' },
          { number: '24/7', label: 'Kampanya İzleme' }
        ],
        mockupCard: {
          managerName: 'Alex Fisher',
          managerTitle: 'Kampanya Yöneticisi',
          title: 'Google Ads Kampanyası',
          description: 'ROI\'yi maksimize etmek için kapsamlı kampanya stratejisi.',
          details: {
            duration: '30 dk',
            timeSlots: ['15d', '30d', '45d', '1s'],
            meeting: 'Google Meet',
            timezone: 'Europe/İstanbul'
          },
          stats: {
            roi: 'ROI',
            projects: 'Proje',
            support: 'Destek'
          }
        },
        keyBenefits: {
          title: 'Google Ads ile işinizi nasıl büyütürüz',
          subtitle: 'Hedefli kampanyalarla doğru müşterilere ulaşın, dönüşümleri artırın ve rekabet avantajı elde edin.',
          benefits: [
            { title: 'Hedefli Reklam Stratejileri', description: 'Google Ads ile doğru kitleye, doğru zamanda ulaşın. Demografik hedefleme, davranışsal analiz ve anahtar kelime optimizasyonu ile kampanyalarınızı maksimum verimle yönetin.' },
            { title: 'Verimli Kampanya Yönetimi', description: 'Yüksek hacimli kampanyaları kolaylıkla yönetin. A/B testleri, otomatik teklif stratejileri ve detaylı raporlamalarla sürekli optimizasyon sağlayın.' },
            { title: 'Olağanüstü ROI Performansı', description: 'Profesyonel kampanya yönetimi, markalı raporlama sayfaları ve otomatik bildirimlerle müşterilerinize mükemmel deneyim sunun ve yatırım getirinizi maksimize edin.' }
          ]
        },
        additionalFeatures: {
          title: 'Maksimum verimlilik için tasarlandı',
          subtitle: 'Gelişmiş özelliklerimiz ve otomatik iş akışlarıyla kampanya performansınızı artırın.'
        },
        faq: {
          title: 'Sıkça Sorulan Sorular',
          subtitle: 'Google Ads hakkında en çok merak edilen sorular',
          items: [
            { question: 'Google Ads nedir ve işime nasıl fayda sağlar?', answer: 'Google Ads, Google arama sonuçlarında ve partner sitelerinde reklamlarınızı göstermenizi sağlar. Hedefli kampanyalarla doğru müşterilere ulaşıp satışlarınızı artırabilirsiniz.' },
            { question: 'Google Ads kampanyası ne kadar sürede sonuç verir?', answer: 'İlk sonuçları 24-48 saat içinde görmeye başlarsınız. Ancak optimize edilmiş kampanyalar için 2-4 haftalık bir süreç öneriyoruz.' },
            { question: 'Minimum bütçe ne kadar olmalı?', answer: 'Sektör ve hedeflerinize göre değişir, ancak aylık minimum 5.000 TL bütçe ile başlamanızı öneriyoruz.' },
            { question: 'Kampanya yönetimi nasıl yapılır?', answer: 'Uzman ekibimiz kampanyalarınızı günlük olarak izler, optimize eder ve aylık detaylı raporlar sunar.' },
            { question: 'ROI nasıl ölçülür?', answer: 'Google Analytics ve conversion tracking ile tüm dönüşümleri takip eder, detaylı ROI raporları sunarız.' }
          ]
        }
      },
      metaAds: {
        tag: 'Meta Ads',
        title: 'Meta Reklamcılığı',
        description: 'Facebook, Instagram ve WhatsApp\'ta milyarlarca kullanıcıya ulaşın. Potansiyel müşterilerinize en doğru anda, en etkili şekilde erişin.',
        features: [
          { title: 'Detaylı Hedefleme', description: 'Demografik, ilgi alanı ve davranış bazlı hedefleme seçenekleri' },
          { title: 'Görsel Reklamlar', description: 'Etkileyici görseller ve videolarla dikkat çekin' },
          { title: 'Stories Reklamları', description: 'Tam ekran deneyimi ile etkili hikayeler anlatın' },
          { title: 'Lookalike Audiences', description: 'Mevcut müşterilerinize benzer kişilere ulaşın' },
          { title: 'Engagement Kampanyaları', description: 'Etkileşimi artıran kampanyalarla topluluk oluşturun' },
          { title: 'Remarketing', description: 'Web sitenizi ziyaret edenlere tekrar ulaşın' }
        ],
        mockupCard: {
          managerName: 'Alex Fisher',
          managerTitle: 'Kampanya Yöneticisi',
          title: 'Meta Ads Kampanyası',
          description: 'Facebook ve Instagram\'da milyarlarca kullanıcıya ulaşın.',
          details: {
            duration: '30 dk',
            timeSlots: ['15d', '30d', '45d', '1s'],
            meeting: 'Zoom',
            timezone: 'Europe/İstanbul'
          },
          stats: {
            users: 'Kullanıcı',
            campaigns: 'Kampanya',
            response: 'Yanıt'
          }
        },
        keyBenefits: {
          title: 'Meta Ads ile işinizi nasıl büyütürüz',
          subtitle: '4.2 milyar kullanıcıya ulaşın, hedefli kampanyalarla dönüşümlerinizi artırın.',
          benefits: [
            { title: 'Gelişmiş Hedefleme', description: 'Facebook ve Instagram\'da demografik, ilgi alanı ve davranış bazlı hedefleme ile potansiyel müşterilerinize ulaşın.' },
            { title: 'Etkili Kampanya Stratejileri', description: 'Yüksek hacimli kampanyaları otomatik optimizasyon araçları ile yönetin. Pixel tracking ve custom audiences ile remarketing yapın.' },
            { title: 'Mükemmel Müşteri Deneyimi', description: 'Profesyonel reklam tasarımları, A/B testleri ve otomatik raporlamalarla sürekli iyileştirme sağlayın.' }
          ]
        },
        additionalFeatures: {
          title: 'Maksimum verimlilik için tasarlandı',
          subtitle: 'Gelişmiş özelliklerimiz ve otomatik iş akışlarıyla Meta kampanya performansınızı artırın.'
        },
        faq: {
          title: 'Sıkça Sorulan Sorular',
          subtitle: 'Meta Ads hakkında en çok merak edilen sorular',
          items: [
            { question: 'Meta Ads nedir ve işime nasıl fayda sağlar?', answer: 'Meta Ads, Facebook, Instagram ve WhatsApp\'ta reklamlarınızı göstermenizi sağlar. 4.2 milyar kullanıcıya erişim ile geniş kitleye ulaşabilirsiniz.' },
            { question: 'Hangi platformlarda reklam verebilirim?', answer: 'Facebook, Instagram, Messenger ve WhatsApp\'ta reklam verebilirsiniz. Tüm platformları tek panelden yönetebilirsiniz.' },
            { question: 'Minimum bütçe ne kadar olmalı?', answer: 'Meta Ads için aylık minimum 3.000 TL bütçe ile başlamanızı öneriyoruz. Hedeflerinize göre bu değişebilir.' },
            { question: 'Hedefleme seçenekleri nelerdir?', answer: 'Demografik hedefleme, ilgi alanları, davranış bazlı hedefleme, lookalike audiences ve custom audiences kullanabilirsiniz.' },
            { question: 'Kampanya sonuçlarını nasıl takip ederim?', answer: 'Meta Business Suite ve Facebook Pixel ile detaylı analitik ve dönüşüm takibi sağlarız. Aylık raporlar ile performansı izlersiniz.' }
          ]
        }
      },
      socialMedia: {
        tag: 'Social Media',
        title: 'Sosyal Medya Yönetimi',
        description: 'Sosyal medya platformlarında güçlü bir varlık oluşturun, topluluk geliştirin ve marka sadakati yaratın.',
        features: [
          { title: 'İçerik Stratejisi', description: 'Hedef kitlenize uygun, etkileşim odaklı içerik planlama' },
          { title: 'Topluluk Yönetimi', description: 'Takipçilerinizle etkileşim ve topluluk oluşturma' },
          { title: 'Büyüme Stratejisi', description: 'Organik ve ücretli büyüme taktikleri' },
          { title: 'Engagement Artırma', description: 'Etkileşim oranlarını maksimize etme' },
          { title: 'Marka Bilinirliği', description: 'Görünürlük ve marka farkındalığı oluşturma' },
          { title: 'Influencer İşbirlikleri', description: 'Etkili influencer kampanyaları yönetimi' }
        ],
        mockupCard: {
          managerName: 'Alex Fisher',
          managerTitle: 'Sosyal Medya Yöneticisi',
          title: 'İçerik Stratejisi',
          description: 'Etkileşimli içeriklerle topluluğunuzu oluşturun.',
          details: {
            duration: '30 dk',
            timeSlots: ['15d', '30d', '45d', '1s'],
            meeting: 'Zoom',
            timezone: 'Europe/İstanbul'
          },
          stats: {
            followers: 'Takipçi',
            engagement: 'Etkileşim',
            posts: 'Gönderi/ay'
          }
        },
        keyBenefits: {
          title: 'Sosyal medya ile işinizi nasıl büyütürüz',
          subtitle: 'Güçlü içerik stratejileri ve topluluk yönetimi ile marka bilinirliğinizi artırın.',
          benefits: [
            { title: 'İçerik Stratejisi', description: 'Hedef kitlenize uygun, etkileşim odaklı içerikler oluşturun. Tutarlı yayın takvimleri ile marka görünürlüğünüzü artırın.' },
            { title: 'Topluluk Yönetimi', description: 'Takipçilerinizle etkileşim kurun, yorumları yönetin ve sadık bir topluluk oluşturun.' },
            { title: 'Performans Analizi', description: 'Detaylı raporlama ve analitik ile stratejinizi sürekli iyileştirin.' }
          ]
        },
        additionalFeatures: {
          title: 'Maksimum verimlilik için tasarlandı',
          subtitle: 'Gelişmiş özelliklerimiz ile sosyal medya performansınızı artırın.'
        },
        faq: {
          title: 'Sıkça Sorulan Sorular',
          subtitle: 'Sosyal medya yönetimi hakkında en çok merak edilen sorular',
          items: [
            { question: 'Sosyal medya yönetimi nedir?', answer: 'Sosyal medya yönetimi, markanızın sosyal platformlardaki varlığını stratejik olarak yönetmektir.' },
            { question: 'Hangi platformlarda hizmet veriyorsunuz?', answer: 'Instagram, Facebook, LinkedIn, Twitter, TikTok ve Pinterest platformlarında hizmet sunuyoruz.' },
            { question: 'İçerikler ne sıklıkla paylaşılır?', answer: 'Stratejinize göre haftada 3-5 gönderi öneriyoruz.' },
            { question: 'Topluluk yönetimi nedir?', answer: 'Takipçilerinizle etkileşim kurmak, yorumları yanıtlamak ve marka sadakati oluşturmaktır.' },
            { question: 'Performans nasıl ölçülür?', answer: 'Etkileşim oranları, erişim, takipçi artışı gibi metrikleri detaylı raporlarla sunuyoruz.' }
          ]
        }
      },
      webDesign: {
        tag: 'Web Design',
        title: 'Web Sitesi Tasarımı',
        description: 'Modern, hızlı ve dönüşüm odaklı web siteleri ile dijital varlığınızı güçlendirin.',
        features: [
          { title: 'Responsive Tasarım', description: 'Tüm cihazlarda mükemmel görünüm' },
          { title: 'Hızlı Yükleme', description: 'Optimize edilmiş performans' },
          { title: 'SEO Dostu', description: 'Arama motorları için optimize' },
          { title: 'Güvenli Altyapı', description: 'SSL sertifikası ve güvenlik' },
          { title: 'Modern Tasarım', description: 'Güncel tasarım trendleri' },
          { title: 'Mobil Öncelikli', description: 'Mobile-first yaklaşım' }
        ],
        portfolioSection: {
          badge: 'Portfolio',
          title: 'Referans Web Sitelerimiz',
          subtitle: 'Başarılı işletmeler için tasarladığımız web siteleri. Her proje, kullanıcı deneyimi ve dönüşüm odaklı yaklaşımla geliştirildi.'
        },
        portfolioSites: [
          { name: 'SmartIQ', description: 'Otomobil işletmeleri için kârlılık odaklı dijital çözümler', url: 'http://smartiq.io/' },
          { name: 'MCD Bag', description: 'Premium bebek çantaları ve aksesuarları', url: 'https://mcdbag.com/' },
          { name: 'Veela', description: 'Cilt ve saç bakım kozmetik markası', url: 'https://veela.com.tr/' },
          { name: 'TasarlaBas', description: 'Yaratıcı tasarım çözümleri ve hizmetleri', url: 'https://tasarlabas.com/' },
          { name: 'Daphne Sandals', description: 'Premium ayakkabı ve sandalet koleksiyonu', url: 'https://daphnesandals.com/' },
          { name: 'Cheesecake Istanbul', description: 'Lezzetli cheesecake ve tatlı çeşitleri', url: 'https://cheesecakeistanbul.com/' },
          { name: 'Firuze Showroom', description: 'Modern kadın giyim ve moda ürünleri', url: 'https://firuzeshowroom.com/' },
          { name: 'Dore Hareket Eğitimi', description: 'Hareket eğitimi ve danışmanlık hizmetleri', url: 'https://dorehareketegitimi.com/' }
        ],
        visitButton: 'Ziyaret Et',
        keyBenefits: {
          title: 'Web tasarımı ile işinizi nasıl büyütürüz',
          subtitle: 'Modern, hızlı ve dönüşüm odaklı web siteleri ile dijital varlığınızı güçlendirin.',
          benefits: [
            { title: 'Modern ve Responsive Tasarım', description: 'Tüm cihazlarda mükemmel görünüm sağlayan responsive web siteleri tasarlıyoruz. Mobile-first yaklaşım ile kullanıcı deneyimini optimize ediyoruz.' },
            { title: 'Hızlı ve Optimize Performans', description: 'SEO dostu, hızlı yüklenen ve güvenli web siteleri oluşturuyoruz. Core Web Vitals optimizasyonu ile arama motorlarında üst sıralarda yer almanızı sağlıyoruz.' },
            { title: 'Dönüşüm Odaklı Tasarım', description: 'Kullanıcı davranışlarını analiz ederek dönüşüm oranlarını artıran web siteleri tasarlıyoruz. A/B testleri ve analitik ile sürekli iyileştirme sağlıyoruz.' }
          ]
        },
        additionalFeatures: {
          title: 'Kapsamlı web tasarım çözümleri',
          subtitle: 'Tüm web tasarım ihtiyaçlarınız için profesyonel hizmetler sunuyoruz.'
        },
        faq: {
          title: 'Sıkça Sorulan Sorular',
          subtitle: 'Web sitesi tasarımı hakkında en çok merak edilen sorular',
          items: [
            { question: 'Web sitesi tasarım süreci nasıl işler?', answer: 'İhtiyaç analizi, tasarım, geliştirme ve test aşamalarından oluşan kapsamlı bir süreç izliyoruz. Ortalama 4-8 hafta sürmektedir.' },
            { question: 'Hangi teknolojileri kullanıyorsunuz?', answer: 'React, Next.js, WordPress, Shopify gibi modern teknolojiler kullanıyoruz. Projenizin ihtiyacına göre en uygun teknolojiyi seçiyoruz.' },
            { question: 'SEO optimizasyonu dahil mi?', answer: 'Evet, tüm web sitelerimiz SEO dostu olarak tasarlanır ve arama motorları için optimize edilir.' },
            { question: 'Web sitesi bakım ve güncelleme hizmeti veriyor musunuz?', answer: 'Evet, web sitenizin güncel kalması için düzenli bakım ve güncelleme hizmetleri sunuyoruz.' },
            { question: 'Mobil uyumluluk garantili mi?', answer: 'Evet, tüm web sitelerimiz mobile-first yaklaşım ile tasarlanır ve tüm cihazlarda mükemmel görünüm sağlar.' }
          ]
        }
      },
      seoGeo: {
        tag: 'SEO & GEO',
        title: 'SEO & GEO Yönetimi',
        description: 'Arama motorlarında üst sıralarda yer alın. Organik trafik ve görünürlük artışı ile dijital başarınızı garanti altına alın.',
        features: [
          { title: 'Keyword Research', description: 'En etkili anahtar kelimeleri bulun ve rakiplerinizi analiz edin' },
          { title: 'SEO Optimizasyonu', description: 'Teknik ve içerik odaklı SEO ile üst sıralarda yer alın' },
          { title: 'Local SEO', description: 'Google My Business optimizasyonu ile yerel aramalarda görünür olun' },
          { title: 'Detaylı Analiz', description: 'Performans metriklerini takip edin ve iyileştirme fırsatlarını yakalayın' },
          { title: 'Hızlı Sonuçlar', description: 'Görünürlüğünüzü 3-6 ay içinde önemli ölçüde artırın' },
          { title: 'Güvenli Yöntemler', description: 'Beyaz şapka SEO teknikleri ile kalıcı ve sürdürülebilir başarı' }
        ],
        services: [
          'Teknik SEO Denetimi',
          'Keyword Research & Analiz',
          'On-Page SEO Optimizasyonu',
          'Off-Page SEO Stratejileri',
          'Google My Business Optimizasyonu',
          'Local Citation Building',
          'Backlink Analiz & Yönetimi',
          'İçerik Optimizasyonu',
          'Aylık SEO Raporlama',
          'Core Web Vitals Optimizasyonu'
        ],
        keyBenefits: {
          title: 'SEO & GEO ile işinizi nasıl büyütürüz',
          subtitle: 'Organik görünürlük ve yerel arama optimizasyonu ile sürdürülebilir büyüme sağlayın.',
          benefits: [
            { title: 'Organik Trafik Artışı', description: 'Arama motorlarında üst sıralarda yer alarak organik ziyaretçilerinizi artırın ve maliyet-etkin bir şekilde dijital varlığınızı güçlendirin.' },
            { title: 'Yerel Görünürlük', description: 'Google My Business optimizasyonu ve lokal SEO stratejileriyle yerel müşterilerinize en kolay şekilde ulaşın.' },
            { title: 'Uzun Vadeli Başarı', description: 'Beyaz şapka SEO teknikleri ile kalıcı sonuçlar elde edin ve online varlığınızı güvenli şekilde büyütün.' }
          ]
        },
        additionalFeatures: {
          title: 'Tüm SEO & GEO araçları',
          subtitle: 'Kapsamlı SEO ve GEO çözümleri ile dijital varlığınızı güçlendirin.'
        },
        faq: {
          title: 'Sık sorulan sorular',
          subtitle: 'SEO & GEO hakkında en çok merak edilen sorular',
          items: [
            { question: 'SEO sonuçları ne kadar sürede görünür?', answer: 'SEO sonuçları tipik olarak 3-6 ay içinde görünmeye başlar. İlk ay içinde teknik düzenlemeler ve hız iyileştirmeleri tamamlanır. 3 ay sonra organik trafikte artış, 6 ay sonra ise üst sıralarda görünürlük başlar.' },
            { question: 'Local SEO neden önemli?', answer: 'Local SEO, yerel işletmelerin Google Maps ve "yakınımdaki..." aramalarında görünür olmasını sağlar. Yerel müşterilere ulaşmak için kritik bir araçtır ve fiziksel işletmeler için mutlaka gerekir.' },
            { question: 'Aylık SEO raporları neleri içerir?', answer: 'Aylık raporlarımızda organik trafik trendi, anahtar kelime pozisyonları, backlink kazanımları, teknik SEO metrikleri, Google My Business performansı ve iyileştirme önerileri yer alır.' },
            { question: 'SEO ve Google Ads arasındaki fark nedir?', answer: 'SEO organik (ücretsiz) sonuçlar için çalışırken, Google Ads ücretli reklamlardır. SEO uzun vadeli ve kalıcı sonuçlar sağlar, Google Ads ise hemen görünürlük sunar. İdeal strateji ikisini birlikte kullanmaktır.' }
          ]
        }
      },
      appDevelopment: {
        tag: 'App Development',
        title: 'Mobil & Web Uygulama Geliştirme',
        description: 'İşletmeniz için özel mobil ve web uygulamaları ile dijital dünyada rekabet avantajı elde edin.',
        features: [
          { title: 'Native Mobil Uygulamalar', description: 'iOS ve Android için performanslı native uygulamalar' },
          { title: 'Web Uygulamaları', description: 'Modern teknolojilerle responsive web uygulamaları' },
          { title: 'Cross-Platform', description: 'React Native ve Flutter ile tek kod tabanı' },
          { title: 'UI/UX Tasarım', description: 'Kullanıcı odaklı modern arayüz tasarımları' },
          { title: 'API Entegrasyonu', description: 'Üçüncü parti servislerle entegrasyon' },
          { title: 'Bakım & Destek', description: 'Sürekli güncelleme ve teknik destek' }
        ],
        keyBenefits: {
          title: 'Uygulama geliştirme ile işinizi nasıl büyütürüz',
          subtitle: 'Özel uygulamalar ile dijital dönüşümünüzü gerçekleştirin ve müşteri deneyimini artırın.',
          benefits: [
            { title: 'Özel Çözümler', description: 'İşletmenizin ihtiyaçlarına özel tasarlanan mobil ve web uygulamaları ile operasyonel verimliliğinizi artırın.' },
            { title: 'Modern Teknolojiler', description: 'React Native, Flutter, Node.js gibi güncel teknolojilerle hızlı, güvenli ve ölçeklenebilir uygulamalar geliştiriyoruz.' },
            { title: 'Sürekli Destek', description: 'Uygulamanızın güncel kalması için düzenli güncellemeler, bakım ve teknik destek hizmetleri sunuyoruz.' }
          ]
        },
        additionalFeatures: {
          title: 'Kapsamlı uygulama geliştirme çözümleri',
          subtitle: 'Tüm uygulama geliştirme ihtiyaçlarınız için profesyonel hizmetler sunuyoruz.'
        },
        faq: {
          title: 'Sıkça Sorulan Sorular',
          subtitle: 'Uygulama geliştirme hakkında en çok merak edilen sorular',
          items: [
            { question: 'Mobil uygulama geliştirme süreci nasıl işler?', answer: 'İhtiyaç analizi, tasarım, geliştirme, test ve yayınlama aşamalarından oluşan kapsamlı bir süreç izliyoruz. Ortalama 3-6 ay sürmektedir.' },
            { question: 'Hangi teknolojileri kullanıyorsunuz?', answer: 'React Native, Flutter, Swift, Kotlin, Node.js, React, Next.js gibi modern teknolojiler kullanıyoruz. Projenizin ihtiyacına göre en uygun teknolojiyi seçiyoruz.' },
            { question: 'Native mi yoksa cross-platform mu?', answer: 'Her iki seçenek de avantajlarına göre değerlendirilir. Native uygulamalar daha yüksek performans, cross-platform ise daha hızlı geliştirme ve düşük maliyet sunar.' },
            { question: 'Uygulama bakım hizmeti veriyor musunuz?', answer: 'Evet, uygulamanızın güncel kalması için düzenli güncelleme, bakım ve teknik destek hizmetleri sunuyoruz.' },
            { question: 'App Store ve Google Play\'e yükleme dahil mi?', answer: 'Evet, uygulamanızın App Store ve Google Play\'e yüklenmesi ve yayınlanması süreçlerini yönetiyoruz.' }
          ]
        }
      },
      marketplace: {
        tag: 'Marketplace',
        title: 'Pazar Yeri Danışmanlığı',
        description: 'Trendyol, Amazon, Hepsiburada gibi pazaryerlerinde satış stratejilerinizi optimize edin ve satışlarınızı artırın.',
        features: [
          { title: 'Pazar Yeri Stratejisi', description: 'Doğru pazaryeri seçimi ve satış stratejisi geliştirme' },
          { title: 'Ürün Optimizasyonu', description: 'Ürün listeleri, başlıklar ve açıklamaları optimize etme' },
          { title: 'Fiyat Stratejisi', description: 'Rekabetçi fiyatlandırma ve promosyon planlaması' },
          { title: 'Stok Yönetimi', description: 'Stok takibi ve tedarik zinciri optimizasyonu' },
          { title: 'Müşteri Hizmetleri', description: 'Pazaryeri müşteri desteği ve yorum yönetimi' },
          { title: 'Performans Analizi', description: 'Satış metrikleri ve raporlama' }
        ],
        keyBenefits: {
          title: 'Pazaryeri danışmanlığı ile işinizi nasıl büyütürüz',
          subtitle: 'Trendyol, Amazon, Hepsiburada gibi pazaryerlerinde satış stratejilerinizi optimize edin ve satışlarınızı artırın.',
          benefits: [
            { title: 'Pazaryeri Stratejisi', description: 'Doğru pazaryeri seçimi ve satış stratejisi geliştirme ile pazar payınızı artırın. Trendyol, Amazon, Hepsiburada gibi platformlarda başarılı olun.' },
            { title: 'Ürün Optimizasyonu', description: 'Ürün listeleri, başlıklar, açıklamalar ve görselleri optimize ederek görünürlüğünüzü ve satışlarınızı artırın.' },
            { title: 'Performans Yönetimi', description: 'Satış metrikleri, stok yönetimi ve müşteri hizmetleri ile pazaryeri performansınızı sürekli iyileştirin.' }
          ]
        },
        additionalFeatures: {
          title: 'Kapsamlı pazaryeri çözümleri',
          subtitle: 'Tüm pazaryeri ihtiyaçlarınız için profesyonel danışmanlık hizmetleri sunuyoruz.'
        },
        faq: {
          title: 'Sıkça Sorulan Sorular',
          subtitle: 'Pazaryeri danışmanlığı hakkında en çok merak edilen sorular',
          items: [
            { question: 'Hangi pazaryerlerinde hizmet veriyorsunuz?', answer: 'Trendyol, Amazon, Hepsiburada, GittiGidiyor, N11 gibi tüm büyük pazaryerlerinde hizmet sunuyoruz.' },
            { question: 'Pazaryeri satış stratejisi nasıl geliştirilir?', answer: 'Pazar analizi, ürün optimizasyonu, fiyat stratejisi, stok yönetimi ve müşteri hizmetleri gibi alanlarda kapsamlı bir strateji geliştiriyoruz.' },
            { question: 'Pazaryeri komisyon oranları nedir?', answer: 'Pazaryerlerine göre komisyon oranları değişir. Genellikle %8-15 arası komisyon alınır. Detaylı bilgi için bizimle iletişime geçin.' },
            { question: 'Stok yönetimi nasıl yapılır?', answer: 'Stok takibi, tedarik zinciri optimizasyonu ve otomatik bildirimler ile stok yönetiminizi optimize ediyoruz.' },
            { question: 'Pazaryeri performans raporları neleri içerir?', answer: 'Aylık raporlarımızda satış trendi, ürün performansı, müşteri yorumları, stok durumu ve iyileştirme önerileri yer alır.' }
          ]
        }
      },
      mentorluk: {
        tag: 'Mentörlük',
        title: 'Dijital Pazarlama Mentörlüğü',
        description: 'Uzman mentörlerimizden birebir danışmanlık alarak dijital pazarlama becerilerinizi geliştirin, stratejilerinizi optimize edin ve işletmenizi bir sonraki seviyeye taşıyın.',
        features: [
          { title: 'Birebir Mentörlük Seansları', description: 'Uzman mentörlerimizle birebir görüşmeler yaparak stratejilerinizi geliştirin' },
          { title: 'Kişiselleştirilmiş Stratejiler', description: 'İşletmenize özel dijital pazarlama stratejileri ve yol haritaları oluşturun' },
          { title: 'Hedef Belirleme ve Takip', description: 'Net hedefler belirleyin ve düzenli takiplerle ilerlemenizi ölçün' },
          { title: 'Uygulamalı Eğitim', description: 'Teorik bilgilerin yanı sıra gerçek projeler üzerinde pratik yapın' },
          { title: 'Sürekli Destek', description: 'Sorularınızı anında yanıtlayın ve mentörlük sürecinde sürekli rehberlik alın' },
          { title: 'Performans Optimizasyonu', description: 'Mevcut kampanyalarınızı analiz edin ve optimize edin' }
        ],
        services: [
          'Google Ads Mentörlüğü',
          'Meta Ads Strateji Geliştirme',
          'SEO Optimizasyon Rehberliği',
          'E-Ticaret Stratejileri',
          'Sosyal Medya Yönetimi',
          'İçerik Pazarlama Planlaması',
          'Dönüşüm Optimizasyonu',
          'Analitik ve Raporlama',
          'Pazar Yeri Danışmanlığı',
          'Shopify Optimizasyonu'
        ],
        keyBenefits: {
          title: 'Mentörlük ile işinizi nasıl büyütürüz',
          subtitle: 'Uzman rehberliği ile dijital pazarlama becerilerinizi geliştirin ve işletmenizi bir sonraki seviyeye taşıyın.',
          benefits: [
            { title: 'Birebir Rehberlik', description: 'Uzman mentörlerimizle birebir görüşmeler yaparak stratejilerinizi geliştirin. Kişiselleştirilmiş yol haritaları ile hedeflerinize ulaşın.' },
            { title: 'Pratik Deneyim', description: 'Teorik bilgilerin yanı sıra gerçek projeler üzerinde pratik yaparak deneyim kazanın. Mevcut kampanyalarınızı analiz edin ve optimize edin.' },
            { title: 'Sürekli Destek', description: 'Sorularınızı anında yanıtlayın ve mentörlük sürecinde sürekli rehberlik alın. İşletmenizi bir sonraki seviyeye taşıyın.' }
          ]
        },
        additionalFeatures: {
          title: 'Kapsamlı mentörlük programları',
          subtitle: 'Tüm dijital pazarlama alanlarında uzman rehberliği sunuyoruz.'
        },
        faq: {
          title: 'Sıkça Sorulan Sorular',
          subtitle: 'Dijital pazarlama mentörlüğü hakkında en çok merak edilen sorular',
          items: [
            { question: 'Mentörlük programı nasıl işler?', answer: 'Birebir görüşmeler, kişiselleştirilmiş stratejiler, hedef belirleme ve takip, uygulamalı eğitim ve sürekli destek içeren kapsamlı bir programdır.' },
            { question: 'Hangi konularda mentörlük alabilirim?', answer: 'Google Ads, Meta Ads, SEO, e-ticaret, sosyal medya yönetimi, içerik pazarlama, dönüşüm optimizasyonu ve analitik gibi tüm dijital pazarlama alanlarında mentörlük sunuyoruz.' },
            { question: 'Mentörlük seansları ne kadar sürer?', answer: 'Seans süresi ihtiyacınıza göre değişir. Genellikle 1-2 saatlik seanslar önerilir. Haftalık veya aylık programlar düzenlenebilir.' },
            { question: 'Online mı yoksa yüz yüze mi?', answer: 'Hem online hem de yüz yüze mentörlük seansları sunuyoruz. Tercihinize göre en uygun yöntemi seçebilirsiniz.' },
            { question: 'Mentörlük programı ne kadar sürer?', answer: 'Program süresi hedeflerinize ve ihtiyaçlarınıza göre değişir. Genellikle 3-6 aylık programlar önerilir, ancak daha kısa veya uzun süreli programlar da düzenlenebilir.' }
          ]
        }
      }
    },
    // Home Page
    home: {
      hero: {
        newRelease: 'New Release',
        messages: [
          {
            title: 'Dijital Büyümenin Güvenilir Ortağı',
            description: 'Veri odaklı stratejiler ve kanıtlanmış yöntemlerle markanızı dijital dünyada zirveye taşıyoruz. ROI odaklı çözümlerle büyümenizi hızlandırın.',
          },
          {
            title: 'E-Ticaretin Görünmez Engellerini Kaldırıyoruz.',
            description: 'Kötü dönüşüm oranları, yetersiz trafik ve karmaşık pazar yeri kuralları geride kalsın.',
          },
          {
            title: 'Veriyle Tasarlarız, Stratejiyle Büyütürüz.',
            description: 'Performans reklamcılığı, veri analitiği ve dönüşüm optimizasyonuyla markanızı dijitalde güçlendiriyoruz.',
          },
          {
            title: 'Yaratıcılığı, Veriyi ve Teknolojiyi Bir Araya Getiriyoruz.',
            description: 'Shopify mağazanızdan sosyal medyanıza kadar, markanızın dijital ekosistemini uçtan uca optimize ediyoruz.',
          },
          {
            title: 'Sadece Görünür Olmayın, Hatırlanan Bir Marka Olun.',
            description: 'Veri odaklı stratejilerimizle reklam harcamalarınızı kâra dönüştürün.',
          },
        ],
        contactButton: 'İletişime Geçin',
        exploreServices: 'Hizmetleri İncele',
      },
                  trustedBy: 'Türkiye\'de hızlı büyüyen kârlı şirketler Thinklyze\'a güveniyor.',
      references: {
        title: 'Hızlı büyüyen markalar Thinklyze\'a güveniyor.',
      },
      servicesSection: {
        title: 'Dijital Pazarlama Hizmetlerimiz',
        subtitle: 'Markanızın dijital varlığını güçlendirmek için kapsamlı çözümler sunuyoruz.'
      },
      services: {
        googleAds: {
          title: 'Google Reklamcılığı',
          description: 'Satışlarınızı artırın ve marka bilinirliğinizi güçlendirin. Google\'ın gücünü markanız için kullanın.',
          features: ['Google Ads Kampanya Yönetimi', 'Anahtar Kelime Optimizasyonu', 'ROI Takip & Raporlama'],
          price: '3.500₺',
          duration: 'Aylık',
          details: 'Detaylar',
        },
        metaAds: {
          title: 'Meta Reklamcılığı',
          description: 'Potansiyel müşterilerinize en doğru anda ulaşın. Facebook ve Instagram\'da etkili reklam kampanyaları.',
          features: ['Facebook & Instagram Ads', 'Hedef Kitle Optimizasyonu', 'Görsel & Video Tasarım'],
          price: '3.000₺',
          duration: 'Aylık',
          details: 'Detaylar',
        },
        socialMedia: {
          title: 'Sosyal M. Yönetimi',
          description: 'Etkileşimi artırın ve sadık bir müşteri kitlesi oluşturun. Sosyal medyada güçlü bir varlık yaratın.',
          features: ['İçerik Üretimi & Planlama', 'Topluluk Yönetimi', 'Etkileşim Analizi'],
          price: '2.500₺',
          duration: 'Aylık',
          details: 'Detaylar',
        },
        webDesign: {
          title: 'Web Sitesi Tasarımı',
          description: 'Dijital varlığınızı en iyi şekilde temsil edin. Modern, hızlı ve dönüşüm odaklı web siteleri.',
          features: ['Modern & Responsive Tasarım', 'SEO Optimizasyonu', 'Hız & Performans'],
          price: '8.000₺',
          duration: 'Proje',
          details: 'Detaylar',
        },
        seoGeo: {
          title: 'SEO & GEO',
          description: 'Arama motorlarında üst sıralarda yer alın. Organik trafik ve görünürlük artışı ile dijital başarınızı garanti altına alın.',
          features: ['Keyword Research & Analiz', 'Teknik SEO Optimizasyonu', 'Google Maps Optimizasyonu'],
          price: '4.500₺',
          duration: 'Aylık',
          details: 'Detaylar',
        },
        appDevelopment: {
          title: 'Uygulama Geliştirme',
          description: 'İşletmenize özel mobil ve web uygulamalar ile dijitalde rekabet avantajı sağlayın.',
          features: ['iOS & Android Geliştirme', 'API Entegrasyonu', 'Bakım & Destek'],
          price: '15.000₺',
          duration: 'Proje',
          details: 'Detaylar',
        },
        marketplace: {
          title: 'Pazar Yeri Danışmanlığı',
          description: 'Pazar yerlerinde satış stratejilerinizi geliştirerek maksimum kazanç elde edin.',
          features: ['Trendyol & Amazon Stratejisi', 'Ürün Listeleme Optimizasyonu', 'Performans Raporlama'],
          price: '4.000₺',
          duration: 'Aylık',
          details: 'Detaylar',
        },
      },
      viewAllServices: 'Tüm Hizmetleri Gör',
      digitalExcellence: {
        teamBadge: '+15 uzman ekibimiz',
        title: 'Dijital Mükemmellikte Yeni Ufuklar Açıyoruz',
        description: 'Mükemmel detaylarla web sayfaları oluşturma yolculuğumuza katılın.',
        cta: 'Özellikleri İncele',
        stats: {
          conversion: 'Dönüşüm Artışı',
          customers: 'Memnun Müşteri'
        },
        features: [
          { title: 'Pixel-Perfect', description: 'Mükemmel detaylarla web siteleri oluşturma yolculuğumuza başlayın.' },
          { title: 'Süper Kontroller', description: 'Kusursuz mükemmel web sayfaları tasarlama yolculuğumuzu başlatın.' },
          { title: 'Online Erişim', description: 'İşletmenizi çeşitli platformlarda yeni müşteriler çekerek ileriye taşıyın.' },
          { title: 'Kolay Kullanım', description: 'İşletmenizi birden fazla platformda müşteri çekerek ileriye taşıyın.' },
          { title: 'Gelişmiş Araçlar', description: 'Profesyonel dijital pazarlama araçlarıyla işinizi büyütün.' },
          { title: '7/24 Destek', description: 'Uzman ekibimizden sürekli destek ve danışmanlık alın.' }
        ]
      },
      advancedFeatures: {
        badge: 'Güçlü Özellikler',
        title: 'Web Sitenizle Geleceği Yakalayın',
        subtitle: 'İşletmenizi platformlarda müşteri çekerek ileriye taşıyın.',
        sectionBadge: 'Gelişmiş Özellikler',
        sectionTitle: 'Web sitenizi gerçek bir sektör lideri haline getirin.',
        sectionDescription: 'Görsel olarak etkileyici ve teknik olarak sağlam dijital deneyimler oluşturmanızı sağlayan araçlarla web tasarımının yeni sınırlarını keşfedin.',
        cta: 'Web Tasarım Hizmetleri',
        viewAllWebsites: 'Tüm Referans Web Sitelerini Gör'
      },
      marketingTools: {
        badge: 'Hesaplama Araçları',
        title: 'Pazarlama Hesaplama Araçları',
        description: 'Reklam verenler için profesyonel pazarlama metrikleri hesaplama araçları. ROAS, ROI, CPM ve daha fazlası ile kampanyalarınızı optimize edin.',
        cta: 'Tüm Hesaplama Araçlarını Gör',
        moreToolsLabel: '+{count} araç daha',
        categories: [
          {
            id: 'roas-roi',
            name: 'ROAS & ROI',
            description: 'Reklam getirisi ve yatırım analizleri',
            tools: ['E-Ticaret Ekonomisi', 'ROAS Hesaplama', 'ROI Hesaplama', 'CPM Hesaplama'],
          },
          {
            id: 'influencer',
            name: 'Influencer Marketing',
            description: 'Influencer kampanya metrikleri',
            tools: ['Etkileşim Oranı', 'Influencer CPM'],
          },
          {
            id: 'budget',
            name: 'Bütçe Planlama',
            description: 'Kampanya bütçe optimizasyonu',
            tools: ['Günlük Bütçe', 'Bütçe Dağılımı', 'Platform Bazlı Dağılım', 'ROI Hedefli Bütçe'],
          },
          {
            id: 'social',
            name: 'Sosyal Medya',
            description: 'Sosyal medya performans metrikleri',
            tools: ['Etkileşim Oranı', 'Tıklama Oranı (CTR)'],
          },
          {
            id: 'ecommerce',
            name: 'E-ticaret KPI',
            description: 'E-ticaret performans göstergeleri',
            tools: ['LTV Hesaplama', 'CAC Hesaplama', 'LTV/CAC Oranı'],
          },
          {
            id: 'content',
            name: 'İçerik Analizi',
            description: 'İçerik performans ölçümleri',
            tools: ['İçerik ROI', 'Dönüşüm Oranı'],
          },
        ],
      },
    },
    // About Page
    about: {
      badge: 'Hakkımızda',
      title: 'Hakkımızda',
      subtitle: '2019\'dan beri dijital pazarlama alanında markaları büyüten, sonuç odaklı çözümler üreten bir ekibiz.',
      storyTitle: 'Hikayemiz',
      storyParagraphs: [
        'Thinklyze, dijital dünyada markaların potansiyelini açığa çıkarma vizyonuyla 2019 yılında kuruldu. Kurucu ekibimizin 10+ yıllık deneyimi ve dijital pazarlama alanındaki tutkusu, bugün geldiğimiz noktanın temelini oluşturuyor.',
        'Başlangıçta küçük bir ekip olarak yola çıktık, ancak müşterilerimizin başarısına odaklanmamız ve elde ettiğimiz sonuçlar sayesinde hızla büyüdük. Her proje bizim için yeni bir öğrenme fırsatı ve mükemmelliğe ulaşma yolunda bir adım.',
        'Bugün 150+ mutlu müşterimizle, dijital pazarlama alanında güvenilir bir partner olarak markaların büyüme yolculuğunda yanlarında olmaya devam ediyoruz.'
      ],
      stats: {
        customers: 'Mutlu Müşteri',
        projects: 'Tamamlanan Proje',
        experience: 'Yıl Tecrübe',
        roi: 'Ortalama ROI Artışı'
      },
      valuesTitle: 'Değerlerimiz',
      valuesSubtitle: 'İş yapış şeklimizi şekillendiren temel değerlerimiz',
      values: [
        { title: 'Sonuç Odaklı', description: 'Her projede ölçülebilir sonuçlar elde etmek için çalışıyoruz.' },
        { title: 'Müşteri Memnuniyeti', description: 'Müşterilerimizin başarısı bizim en büyük motivasyonumuzdur.' },
        { title: 'İnovatif Yaklaşım', description: 'Sürekli öğrenen ve yenilikçi çözümler üreten bir ekibiz.' },
        { title: 'Güvenilirlik', description: 'Şeffaf iletişim ve dürüst yaklaşımla güven inşa ediyoruz.' }
      ],
      missionTitle: 'Misyonumuz',
      missionSubtitle: 'Dijital dünyada markaların başarı hikayelerini yazmak',
      mission: {
        badge: 'Vizyonumuz',
        title: 'Dijital Dönüşümün Öncüsü',
        description: 'Dijital pazarlama ve performans reklamcılığı konusunda Türkiye\'nin en güvenilir ve yenilikçi ajansı olmak. Müşterilerimize veri odaklı stratejiler ve ölçülebilir sonuçlarla değer katmak.',
        features: [
          'Veri odaklı stratejiler geliştirmek',
          'Ölçülebilir sonuçlar sağlamak',
          'Sürekli öğrenen ve gelişen bir ekip olmak',
          'Müşteri başarısını öncelik yapmak'
        ]
      },
      milestones: [
        { year: '2019', title: 'Kuruluş', description: 'Thinklyze, dijital pazarlama alanında hizmet vermeye başladı.' },
        { year: '2020', title: '50+ Müşteri', description: 'İlk yılımızda 50\'den fazla müşteriye hizmet verdik.' },
        { year: '2021', title: 'Ekip Genişlemesi', description: 'Uzman ekibimizi genişleterek hizmet kalitemizi artırdık.' },
        { year: '2022', title: '100+ Proje', description: '100\'den fazla başarılı proje tamamladık.' },
        { year: '2023', title: 'Ödül', description: 'En İyi Dijital Pazarlama Ajansı ödülünü aldık.' },
        { year: '2024', title: 'Büyüme', description: '150+ aktif müşteri ile büyümeye devam ediyoruz.' }
      ]
    },
    // Academy Page
    academy: {
      badge: 'Akademi',
      title: 'Dijital Pazarlama Akademisi',
      subtitle: 'Dijital pazarlama alanında kendinizi geliştirin. Video derslerimiz ile uzman seviyesine ulaşın.',
      videosSection: {
        badge: 'Video Derslerimiz',
        title: 'Dijital pazarlamayı öğrenin',
        description: 'Uzman ekibimiz tarafından hazırlanan interaktif video dersler ile dijital pazarlama becerilerinizi geliştirin.'
      }
    },
    // Marketing Tools Page
    marketingTools: {
      badge: 'Hesaplama Araçları',
      title: 'Pazarlama Hesaplama Araçları',
      subtitle: 'Reklam kampanyalarınızı optimize etmek için profesyonel hesaplama araçları. ROAS, ROI, CPM ve daha fazlasını kolayca hesaplayın.',
      selectCategory: 'Kategori Seç',
      buttons: {
        downloadPDF: 'PDF Rapor İndir',
        shareResult: 'Sonucu Paylaş'
      },
      faq: {
        title: 'Sık Sorulan Sorular',
        subtitle: 'E-Ticaret Ekonomisi Hesaplama Aracı hakkında merak ettiğiniz soruların yanıtları',
        items: [
          {
            question: 'ROI ve ROAS nedir? Aralarındaki fark nedir?',
            answer: 'ROI (Return on Investment) yatırım getiri oranıdır ve tüm maliyetleri içerir. ROAS (Return on Ad Spend) ise sadece reklam harcamasını içerir. ROI yüzde olarak ifade edilir (örn: %250), ROAS ise oran olarak ifade edilir (örn: 4:1). Detaylı bilgi için <a href=\'/blog/roi-nedir-nasil-hesaplanir-2025-rehberi\' class=\'text-blue-600 hover:text-blue-800 underline\'>ROI rehberimizi</a> ve <a href=\'/blog/roas-nedir-nasil-hesaplanir-reklam-verimliligi-rehberi\' class=\'text-blue-600 hover:text-blue-800 underline\'>ROAS rehberimizi</a> okuyabilirsiniz.'
          },
          {
            question: 'ROAS değeri ne kadar olmalı?',
            answer: 'ROAS değeri sektöre ve ürün kâr marjına göre değişir. Genellikle e-ticaret işletmeleri için 4:1 veya üzeri ROAS değerleri hedeflenir. Ancak ürün kâr marjı düşükse daha yüksek ROAS gerekebilir. Break-even noktası 1:1\'dir, yani bu değerin üzerinde olması gerekir.'
          },
          {
            question: 'CAC (Müşteri Edinme Maliyeti) nasıl hesaplanır?',
            answer: 'Bu hesaplayıcıda CAC, Brüt Kâr - Net Kâr formülü ile otomatik olarak hesaplanır. CAC, bir müşteriyi kazanmak için harcanan toplam maliyettir. CAC değeri ne kadar düşükse, işletme o kadar kârlıdır.'
          },
          {
            question: 'LTV (Lifetime Value) nedir? Nasıl hesaplanır?',
            answer: 'LTV, bir müşterinin işletmeye yaşam boyu sağladığı toplam gelirdir. Bu hesaplayıcıda LTV, Sepet Ortalaması × Müşteri Ortalama Sipariş Sayısı formülü ile hesaplanır. LTV/CAC oranı 3:1 veya üzeri olması önerilir.'
          },
          {
            question: 'KDV neden hesaplamalara dahil edilmiyor?',
            answer: 'KDV, devlet adına tahsil edilen bir vergi olduğu için işletmenin kazancı değildir. Bu nedenle kârlılık analizlerine, maliyet ve ROAS hesaplarına dahil edilmez. Hesaplayıcıda KDV dahil satış fiyatı gösterilir, ancak kâr hesaplamalarında KDV hariç tutulur.'
          },
          {
            question: 'PDF raporu nasıl indirilir?',
            answer: 'Hesaplama sonuçlarınızı PDF olarak indirmek için \'PDF Rapor İndir\' butonuna tıklayın. PDF\'de logo, tarih, tüm hesaplama sonuçları ve sayfa numaraları yer alır. PDF\'i paylaşmak için \'Sonucu Paylaş\' butonunu da kullanabilirsiniz.'
          },
          {
            question: 'Hesaplama sonuçlarını nasıl paylaşabilirim?',
            answer: 'Hesaplama sonuçlarınızı paylaşmak için \'Sonucu Paylaş\' butonuna tıklayın. Bu buton, PDF raporunu paylaşmanıza veya sonuçları metin olarak kopyalamanıza olanak tanır. Web Share API destekleniyorsa PDF dosyası olarak paylaşabilirsiniz.'
          },
          {
            question: 'Hangi alanlar değiştirilebilir?',
            answer: 'Hesaplayıcıda sadece yeşil renkli alanlar ve KDV oranı değiştirilebilir. Sarı renkli alanlar otomatik olarak hesaplanan sonuçlardır ve değiştirilemez. CAC değeri de otomatik hesaplanır (Brüt Kâr - Net Kâr) ve değiştirilemez.'
          },
          {
            question: 'Break-even ROAS nedir?',
            answer: 'Break-even ROAS, kârın sıfır olduğu noktadır. Yani bu ROAS değerinde ne kâr ne de zarar edersiniz. Break-even ROAS değeri, toplam maliyetlerin gelire eşit olduğu noktadır. Bu değerin üzerinde ROAS elde etmeniz gerekir.'
          },
          {
            question: 'Bu hesaplayıcı hangi metrikleri hesaplar?',
            answer: 'Bu hesaplayıcı ROI, ROAS, LTV, CAC, Brüt Kâr, Net Kâr, Break-even ROAS ve kâr yüzdelerini hesaplar. Ayrıca komisyon, ödeme altyapı maliyeti, kargo, paketleme ve iade maliyetlerini de hesaba katar.'
          }
        ]
      },
      ecommerceCalculator: {
        title: 'E-Ticaret Ekonomisi Hesaplayıcı',
        description: 'E-ticaret işletmenizin karlılığını analiz edin',
        inputs: {
          unitPrice: 'Ürün Satış Fiyatı (₺)',
          unitCost: 'Satılan Ürün Maliyeti - COGS (₺)',
          vatRate: 'KDV Oranı (%)',
          vatIncludedPrice: 'KDV Dahil Satış Fiyatı (₺)',
          wholesaleDepot: 'Toptan Alım + Depo Geliş (₺)',
          marketplaceCommission: 'Komisyon Oranı (%)',
          marketplaceCommissionAmount: 'Komisyon Tutarı',
          paymentInfraCommission: 'Ödeme Altyapı Komisyon Oranı (%)',
          paymentInfraCommissionPlaceholder: 'Paytr, İyzico vs. Örneğin 3.75',
          paymentInfraCost: 'Ödeme Altyapı Maliyeti (₺)',
          packagingCost: 'Paketleme Maliyeti (₺)',
          shippingCost: 'Kargo Maliyeti (₺)',
          returnRate: 'İade Oranı (%)',
          returnRateCost: 'İade Oranı Maliyeti (₺)',
          codExpenses: 'Toplam COD Giderleri (₺)',
          cacTarget: 'CAC Hedefi (₺)',
          netProfitTarget: 'Net Kâr Hedefi (₺)',
          adSpend: 'Reklam Harcaması (₺)',
          totalOrders: 'Toplam Sipariş Adedi'
        },
        outputs: {
          revenue: 'Toplam Gelir (₺)',
          totalCosts: 'Toplam Maliyetler (₺)',
          grossProfit: 'Brüt Kâr (₺)',
          netProfit: 'Net Kâr (₺)',
          cac: 'Müşteri Edinim Maliyeti (CAC)',
          roas: 'ROAS',
          roasLabel: 'Minimum hedef 2.5',
          roi: 'ROI (%)',
          breakEvenRoas: 'Break-even ROAS',
          profitMargin: 'Kar Marjı (%)',
          avgOrderCount: 'Müşteri Ortalama Sipariş Sayısı',
          avgBasket: 'Sepet Ortalaması (₺)',
          ltv: 'LTV (₺)',
          ltvCacRatio: 'LTV / CAC Oranı',
          netProfitPercent: 'Net Kâr % (%)',
          grossProfitPercent: 'Brüt Kâr % (%)',
          cacFormula: 'Brüt Kâr - Net Kâr',
          roasFormula: 'Gelir / CAC',
          roiFormula: 'Break-even',
          breakEvenFormula: 'Hesaplanamıyor',
          breakEvenDescription: 'altında zarar, üstünde kâr',
          revenueCacDescription: 'Gelir: {revenue} ₺ / CAC: {cac} ₺'
        },
        vatNote: {
          title: 'KDV Notu:',
          text: 'KDV, devlet adına tahsil edilen bir vergi olduğu için: • İşletmenin kazancı değildir. • Kârlılık analizlerine, maliyet ve ROAS hesaplarına dahil edilmez.'
        },
        tabs: {
          ecommerceEconomics: 'E-Ticaret Ekonomisi',
          roasCalculator: 'ROAS Hesaplama',
          roiCalculator: 'ROI Hesaplama',
          cpmCalculator: 'CPM Hesaplama'
        },
        warning: 'Not: Hesaplamalarda sadece yeşil alanlar ve KDV oranı değiştirilmiştir.',
        videoTitle: 'Nasıl Hesaplanır?',
        videoDescription: 'E-ticaret ekonomisi hesaplamalarının nasıl yapıldığını videomuzda detaylı olarak anlattık.'
      }
    },
    // References Page
    references: {
      title: 'Referanslarımız',
      subtitle: 'Birlikte çalıştığımız markalar ve başarı hikayelerimiz',
      categories: {
        all: 'Tümü',
        shoeBag: 'Ayakkabı & Çanta',
        babyKids: 'Bebek & Çocuk',
        homeFurniture: 'Ev & Mobilya',
        food: 'Gıda',
        service: 'Hizmet',
        personalCare: 'Kişisel Bakım',
        automotive: 'Otomotiv',
        outdoor: 'Outdoor',
        marketplace: 'Pazaryeri',
        healthMedical: 'Sağlık & Medikal',
        jewelry: 'Takı & Mücevherat',
        textile: 'Tekstil & Tesettür',
        electronics: 'Elektronik'
      }
    },
    // Testimonials
    testimonials: {
      tag: 'Referanslar',
      title: 'Sadece bizim söylediklerimize güvenmeyin',
      subtitle: 'Kullanıcılarımız en iyi elçilerimiz. Dijital pazarlama konusunda neden tercih edildiğimizi keşfedin.',
      reviewAll: 'Tüm yorumları inceleyin',
      items: [
        {
          quote: 'Thinklyze ile çalışmak işimizi tamamen dönüştürdü. Veri odaklı yaklaşımları sayesinde dijital pazarlama stratejimizde büyük başarılar elde ettik. Ekip gerçekten profesyonel ve sonuç odaklı.',
          name: 'Ahmet Yılmaz',
          title: 'CEO, TechStart',
          avatar: 'AY'
        },
        {
          quote: 'E-ticaret mağazamız için Thinklyze\'dan aldığımız hizmet gerçekten mükemmel. ROI\'miz %300 arttı ve müşteri tabanımız genişledi. Google Ads kampanyalarımız tamamen optimize edildi.',
          name: 'Zeynep Demir',
          title: 'Kurucu, Moda E-Ticaret',
          avatar: 'ZD'
        },
        {
          quote: 'Dijital pazarlama konusunda aradığımız her şeyi Thinklyze\'da bulduk. Profesyonel ekibi ve sonuç odaklı yaklaşımı ile fark yaratıyorlar. Meta reklamlarımız artık çok daha etkili.',
          name: 'Mehmet Kaya',
          title: 'Pazarlama Direktörü, Global İnc',
          avatar: 'MK'
        },
        {
          quote: 'Shopify mağazamızın SEO ve performans optimizasyonu için Thinklyze ile çalıştık. Organik trafiğimiz 6 ayda 5 katına çıktı. Gerçekten etkileyici sonuçlar aldık.',
          name: 'Ayşe Özkan',
          title: 'Kurucu, TechStore',
          avatar: 'AÖ'
        },
        {
          quote: 'Sosyal medya yönetimi konusunda Thinklyze\'dan destek aldık. İçerik kalitemiz arttı, etkileşim oranlarımız yükseldi ve marka bilinirliğimiz önemli ölçüde gelişti.',
          name: 'Can Yıldız',
          title: 'Marka Müdürü, FashionBrand',
          avatar: 'CY'
        },
        {
          quote: 'Pazar yeri danışmanlığı hizmeti aldık. Trendyol ve Hepsiburada\'daki satışlarımız %400 arttı. Ürün optimizasyonları ve fiyat stratejileri gerçekten başarılı oldu.',
          name: 'Elif Şahin',
          title: 'E-Ticaret Müdürü, RetailCo',
          avatar: 'EŞ'
        },
        {
          quote: 'UGC ve influencer marketing kampanyalarımız Thinklyze sayesinde çok başarılı oldu. Marka bilinirliğimiz geniş kitlelere ulaştı ve müşteri güvenimiz arttı.',
          name: 'Burak Çelik',
          title: 'Kurucu, BeautyBrand',
          avatar: 'BÇ'
        },
        {
          quote: 'Web sitesi tasarımı ve geliştirme projemiz Thinklyze tarafından harika bir şekilde yönetildi. Modern, hızlı ve dönüşüm odaklı bir site elde ettik. Müşteri memnuniyetimiz arttı.',
          name: 'Deniz Kaya',
          title: 'CEO, ServiceCo',
          avatar: 'DK'
        },
        {
          quote: 'App geliştirme projemiz için Thinklyze ile çalıştık. Hem iOS hem Android uygulamalarımız zamanında ve kaliteli bir şekilde teslim edildi. API entegrasyonları mükemmel çalışıyor.',
          name: 'Gökhan Aydın',
          title: 'CTO, TechSolutions',
          avatar: 'GA'
        },
        {
          quote: 'SEO ve GEO hizmetleri sayesinde Google\'da üst sıralara çıktık. Lokal SEO stratejileri ile fiziksel mağazamıza gelen müşteri sayısı önemli ölçüde arttı.',
          name: 'Selin Yılmaz',
          title: 'Pazarlama Müdürü, LocalBusiness',
          avatar: 'SY'
        }
      ]
    },
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      services: 'Services',
      blog: 'Blog',
      academy: 'Academy',
      about: 'About',
      contact: 'Contact',
      references: 'References',
      career: 'Career',
      glossary: 'Glossary',
      education: 'Education',
      consulting: 'Hourly Consulting',
    },
    // Services
    services: {
      googleAds: 'Google Advertising',
      metaAds: 'Meta Advertising',
      socialMedia: 'Social Media Management',
      webDesign: 'Web Design',
      seoGeo: 'SEO & GEO',
      appDevelopment: 'App Development',
      marketplace: 'Marketplace Consulting',
      shopify: 'Shopify E-Commerce',
      ugcInfluencer: 'UGC & Influencer Marketing',
      mentorship: 'Mentorship',
      marketingTools: 'Marketing Tools',
    },
    // Common
    common: {
      getStarted: 'Get started',
      scheduleDemo: 'Schedule a demo',
      learnMore: 'Learn More',
      contactUs: 'Contact Us',
      readMore: 'Read More',
      faq: 'Frequently Asked Questions',
    },
    // Footer
    footer: {
      description: 'Take your business to the next level with our expert team in digital marketing and performance advertising.',
      quickLinks: 'Quick Links',
      services: 'Our Services',
      contact: 'Contact',
      address: 'Zeytinlik Mah. Fişekhane Cad. Carousel No: 5 İç Kapı No: 17 Bakırköy/İstanbul',
      workingHours: 'Working Hours',
      weekdays: 'Monday - Friday: 09:00 - 18:00',
      weekend: 'Saturday - Sunday: Closed',
      rights: 'All rights reserved.',
    },
    // Contact
    contact: {
      title: 'Contact',
      subtitle: 'Get in touch with us',
      description: 'Contact us to achieve your digital marketing goals. Our expert team is ready to offer you the most suitable solution.',
      quoteFormTitle: 'Quote Request Form',
      quoteFormDescription: 'Please fill out the form below so we can offer you the most suitable solution.',
      name: 'Full Name',
      namePlaceholder: 'Your name and surname',
      email: 'Email',
      emailPlaceholder: 'example@email.com',
      phone: 'Phone',
      phonePlaceholder: '+90 (5xx) xxx xx xx',
      company: 'Company',
      companyPlaceholder: 'Your company name',
      service: 'Service of Interest',
      selectService: 'Select service',
      budget: 'Budget Range',
      selectBudget: 'Select budget',
      message: 'Your Message',
      messagePlaceholder: 'Provide detailed information about your project...',
      send: 'Send Message',
      sending: 'Sending...',
      successTitle: 'Thank You!',
      successMessage: 'Your message has been sent successfully. We will get back to you as soon as possible.',
      ourOffice: 'Our Office',
      openMap: 'Open in Map',
      address: 'Zeytinlik Mah. Fişekhane Cad. Carousel No: 5 İç Kapı No: 17',
      city: 'Bakırköy/İstanbul',
      faq: 'Frequently Asked Questions',
      faq1Question: 'How long does it take to see results?',
      faq1Answer: 'SEO efforts show results in 3-6 months, while Google Ads campaigns start showing results within 1-2 weeks.',
      faq2Question: 'Which industries do you work with?',
      faq2Answer: 'We work with all industries including e-commerce, technology, healthcare, education, and finance.',
      faq3Question: 'How is reporting done?',
      faq3Answer: 'We provide monthly detailed performance reports and weekly summary reports.',
      contactInfo: {
        email: {
          title: 'Email',
          details: 'info@thinklyze.com',
          description: 'We respond within 24 hours',
        },
        phone: {
          title: 'Phone',
          details: '0553 657 64 54',
          description: 'Monday - Friday, 09:00 - 18:00',
        },
        address: {
          title: 'Address',
          details: 'Zeytinlik Mah. Fişekhane Cad. Carousel No: 5 İç Kapı No: 17',
          description: 'Bakırköy/İstanbul',
        },
        hours: {
          title: 'Working Hours',
          details: 'Monday - Friday: 09:00 - 18:00',
          description: 'We are at your service on weekdays',
        },
      },
      services: [
        'SEO Optimization',
        'Google Ads Management',
        'Social Media Marketing',
        'Content Marketing',
        'Digital Marketing Consulting',
        'Web Analytics',
        'Other',
      ],
      budgetRanges: [
        '5,000₺ - 10,000₺',
        '10,000₺ - 25,000₺',
        '25,000₺ - 50,000₺',
        '50,000₺ - 100,000₺',
        '100,000₺+',
      ],
      formLabels: {
        name: 'Full Name',
        email: 'Email',
        phone: 'Phone',
        company: 'Company',
        service: 'Service of Interest',
        budget: 'Budget Range',
        message: 'Your Message',
      },
      notSpecified: 'Not Specified',
      quoteRequestForm: 'Quote Request Form',
    },
    // Live Support
    liveSupport: {
      title: 'Live Support',
      placeholder: 'Type your message',
      welcome: 'Hello! Welcome to Thinklyze! 👋',
      help: 'How can I help you? I can answer your questions via WhatsApp.',
      responseTime: 'Usually responds within a few minutes',
      continueWhatsApp: 'Continue on WhatsApp',
      secure: 'Secure and fast communication',
      placeholderText: 'Type your message...',
    },
    // Callback Modal
    callback: {
      title: 'How can we reach you?',
      name: 'Full Name',
      namePlaceholder: 'Your Full Name',
      email: 'Email',
      emailPlaceholder: 'Your Email Address',
      phone: 'Phone',
      phonePlaceholder: 'Your Phone Number',
      company: 'Company Name',
      companyPlaceholder: 'Company Name',
      ecommerce: 'Do you do e-commerce?',
      yes: 'Yes',
      no: 'No',
      starting: 'Just Starting',
      source: 'Where did you hear about Thinklyze?',
      customer: 'From Thinklyze Customers',
      callMe: 'Call Me',
    },
    // Service Descriptions
    serviceDescriptions: {
      googleAds: 'Google Ads and YouTube campaigns',
      metaAds: 'Facebook and Instagram ads',
      socialMedia: 'Community building and content management',
      webDesign: 'Modern and responsive web designs',
      seoGeo: 'Search engine and local SEO optimization',
      appDevelopment: 'iOS, Android and web applications',
      marketplace: 'Trendyol, Amazon and more',
      shopify: 'E-commerce stores and optimization',
      ugcInfluencer: 'User-generated content and influencer collaborations',
      mentorship: 'Digital marketing mentorship and consulting',
      marketingTools: 'ROAS, ROI, CPM and more marketing metrics',
    },
    // Service Pages
    servicePages: {
      common: {
        scheduleMeeting: 'Schedule a Meeting',
        callMe: 'Call Us',
        trustedBy: 'Fast-growing brands trust Thinklyze.',
        getStarted: 'Get started',
        keyBenefits: 'Key benefits',
        additionalFeatures: 'Additional features',
        serviceScope: 'Our Service Scope:',
      },
      ugcInfluencer: {
        tag: 'UGC & Influencer Marketing',
        title: 'UGC & Influencer Marketing',
        description: 'Increase your brand awareness, reach your target audience, and boost your sales with user-generated content and influencer collaborations.',
        features: [
          {
            title: 'UGC Content Creation',
            description: 'Build trust in your brand with authentic content created by real users'
          },
          {
            title: 'Influencer Collaborations',
            description: 'Establish strategic partnerships with influencers suitable for your target audience'
          },
          {
            title: 'Target Audience Analysis',
            description: 'Conduct detailed analysis to find the right influencers and content creators'
          },
          {
            title: 'Campaign Management',
            description: 'Manage and track all your influencer campaigns from a single platform'
          },
          {
            title: 'Brand Alignment',
            description: 'Select content and influencers that align with your brand values'
          },
          {
            title: 'Performance Analysis',
            description: 'Measure campaign performance and maximize ROI'
          }
        ],
        services: [
          'UGC Content Creation and Management',
          'Micro and Macro Influencer Collaborations',
          'Influencer Selection and Analysis',
          'Content Strategy Development',
          'Campaign Planning and Management',
          'Performance Tracking and Reporting',
          'Brand Ambassador Programs',
          'Product Launch Campaigns',
          'Hashtag Campaigns',
          'Content Rights and Legal Compliance'
        ],
        mockupCard: {
          title: 'Influencer Campaign',
          subtitle: 'UGC & Content Marketing',
          heading: 'Brand Awareness Campaign',
          description: 'Reach your target audience through authentic user-generated content and influencer partnerships.',
          metrics: {
            influencers: '50+ Influencers',
            content: '100+ UGC Content',
            reach: '5M+ Reach',
            engagement: '500K+ Engagement'
          },
          stats: {
            roi: 'ROI',
            projects: 'Projects',
            support: 'Support'
          }
        },
        keyBenefits: {
          title: 'How we grow your brand with UGC & Influencer Marketing',
          subtitle: 'Increase your brand awareness and reach your target audience reliably with authentic content and strategic influencer collaborations.',
          benefits: [
            {
              title: 'Authentic Content Creation',
              description: 'Build trust in your brand with authentic content created by real users. Create social proof with UGC campaigns and increase your conversions.'
            },
            {
              title: 'Strategic Influencer Collaborations',
              description: 'Establish strategic partnerships with micro and macro influencers suitable for your target audience. Create maximum impact with the right influencer selection and campaign management.'
            },
            {
              title: 'Measurable Results',
              description: 'Track all your campaigns with detailed analysis and reporting. Continuously optimize your performance with ROI, reach, engagement, and conversion metrics.'
            }
          ]
        },
        additionalFeatures: {
          title: 'We offer comprehensive solutions',
          subtitle: 'Grow your brand with our professional services covering all aspects of UGC and Influencer Marketing.'
        },
        faq: {
          title: 'Frequently Asked Questions',
          subtitle: 'The most frequently asked questions about UGC & Influencer Marketing',
          items: [
            {
              question: 'What is UGC (User Generated Content)?',
              answer: 'UGC is authentic content created by brands\' customers. These contents create strong social proof for your brand and make you appear more trustworthy to potential customers.'
            },
            {
              question: 'How is influencer selection made?',
              answer: 'Professional analysis is conducted considering factors such as your target audience, influencer\'s follower quality, engagement rates, content quality, and brand alignment. The most suitable influencers are selected for you.'
            },
            {
              question: 'How long does an influencer campaign last?',
              answer: 'Campaign duration varies depending on your goals and budget. Generally, 1-3 month campaigns are recommended, but short-term campaigns can also be organized.'
            },
            {
              question: 'How is ROI measured?',
              answer: 'Campaign performance is tracked in detail with metrics such as reach, engagement, website traffic, conversion, and sales, and monthly reports are provided.'
            },
            {
              question: 'Who owns the rights to UGC content?',
              answer: 'Content rights are determined according to campaign terms. Generally, the brand\'s usage rights are obtained and legal compliance is ensured.'
            }
          ]
        }
      },
      googleAds: {
        tag: 'Google Ads',
        title: 'Google Ads Management',
        description: 'Use the power of Google for your brand. Reach the right customers with targeted ads and increase your sales.',
        features: [
          { title: 'Targeted Campaigns', description: 'Reach the right audience, at the right time, with the right message' },
          { title: 'ROI Optimization', description: 'Get maximum return for every click' },
          { title: 'Detailed Analysis', description: 'Track campaign performance in real-time' },
          { title: 'Audience Segmentation', description: 'Effective reach with demographic and behavioral targeting' },
          { title: 'Quick Results', description: 'Start seeing initial results within 24 hours' },
          { title: 'Secure Management', description: 'Secure campaign management with Google Partner certified experts' }
        ],
        services: [
          'Google Ads Campaign Setup',
          'Keyword Research and Analysis',
          'Ad Copy Writing and Optimization',
          'Bidding Strategy Management',
          'Conversion Tracking Setup',
          'A/B Testing Management',
          'Negative Keyword Optimization',
          'Quality Score Improvement',
          'Competitor Analysis',
          'Monthly Performance Reports'
        ],
        campaignTypes: [
          { title: 'Search Campaigns', description: 'Show text ads to users searching on Google', benefits: ['High intent', 'Quick conversion', 'Measurable results'] },
          { title: 'Display Campaigns', description: 'Show your visual ads on millions of websites', benefits: ['Wide reach', 'Brand awareness', 'Remarketing opportunity'] },
          { title: 'Shopping Campaigns', description: 'Promote your e-commerce products on Google', benefits: ['Product image', 'Price information', 'Direct sales'] },
          { title: 'YouTube Campaigns', description: 'Reach your target audience on YouTube with video ads', benefits: ['Visual impact', 'Wide audience', 'Brand story'] }
        ],
        stats: [
          { number: '300%', label: 'Average ROI Increase' },
          { number: '48 Hours', label: 'Campaign Setup Time' },
          { number: '50+', label: 'Successful Projects' },
          { number: '24/7', label: 'Campaign Monitoring' }
        ],
        mockupCard: {
          managerName: 'Alex Fisher',
          managerTitle: 'Campaign Manager',
          title: 'Google Ads Campaign',
          description: 'A comprehensive campaign strategy to maximize ROI.',
          details: {
            duration: '30 mins',
            timeSlots: ['15m', '30m', '45m', '1h'],
            meeting: 'Google Meet',
            timezone: 'Europe/Istanbul'
          },
          stats: {
            roi: 'ROI',
            projects: 'Projects',
            support: 'Support'
          }
        },
        keyBenefits: {
          title: 'How we grow your business with Google Ads',
          subtitle: 'Reach the right customers with targeted campaigns, increase conversions and gain competitive advantage.',
          benefits: [
            { title: 'Targeted Advertising Strategies', description: 'Reach the right audience at the right time with Google Ads. Manage your campaigns with maximum efficiency through demographic targeting, behavioral analysis and keyword optimization.' },
            { title: 'Efficient Campaign Management', description: 'Easily manage high-volume campaigns. Ensure continuous optimization with A/B tests, automated bidding strategies and detailed reporting.' },
            { title: 'Exceptional ROI Performance', description: 'Provide excellent experience to your customers with professional campaign management, branded reporting pages and automated notifications, and maximize your return on investment.' }
          ]
        },
        additionalFeatures: {
          title: 'Designed for maximum efficiency',
          subtitle: 'Increase your campaign performance with our advanced features and automated workflows.'
        },
        faq: {
          title: 'Frequently Asked Questions',
          subtitle: 'The most frequently asked questions about Google Ads',
          items: [
            { question: 'What is Google Ads and how does it benefit my business?', answer: 'Google Ads allows you to show your ads on Google search results and partner sites. You can reach the right customers with targeted campaigns and increase your sales.' },
            { question: 'How long does a Google Ads campaign take to show results?', answer: 'You start seeing initial results within 24-48 hours. However, we recommend a 2-4 week process for optimized campaigns.' },
            { question: 'What should be the minimum budget?', answer: 'It varies depending on your industry and goals, but we recommend starting with a monthly minimum budget of 5,000 TL.' },
            { question: 'How is campaign management done?', answer: 'Our expert team monitors your campaigns daily, optimizes them and provides detailed monthly reports.' },
            { question: 'How is ROI measured?', answer: 'We track all conversions with Google Analytics and conversion tracking, and provide detailed ROI reports.' }
          ]
        }
      },
      metaAds: {
        tag: 'Meta Ads',
        title: 'Meta Advertising',
        description: 'Reach billions of users on Facebook, Instagram and WhatsApp. Reach your potential customers at the right time, in the most effective way.',
        features: [
          { title: 'Detailed Targeting', description: 'Demographic, interest-based and behavioral targeting options' },
          { title: 'Visual Ads', description: 'Attract attention with impressive visuals and videos' },
          { title: 'Stories Ads', description: 'Tell effective stories with full-screen experience' },
          { title: 'Lookalike Audiences', description: 'Reach people similar to your existing customers' },
          { title: 'Engagement Campaigns', description: 'Build a community with campaigns that increase engagement' },
          { title: 'Remarketing', description: 'Reach out again to those who visit your website' }
        ],
        mockupCard: {
          managerName: 'Alex Fisher',
          managerTitle: 'Campaign Manager',
          title: 'Meta Ads Campaign',
          description: 'Reach billions of users across Facebook and Instagram.',
          details: {
            duration: '30 mins',
            timeSlots: ['15m', '30m', '45m', '1h'],
            meeting: 'Zoom',
            timezone: 'Europe/Istanbul'
          },
          stats: {
            users: 'Users',
            campaigns: 'Campaigns',
            response: 'Response'
          }
        },
        keyBenefits: {
          title: 'How we grow your business with Meta Ads',
          subtitle: 'Reach 4.2 billion users, increase your conversions with targeted campaigns.',
          benefits: [
            { title: 'Advanced Targeting', description: 'Reach your potential customers with demographic, interest-based and behavioral targeting on Facebook and Instagram.' },
            { title: 'Effective Campaign Strategies', description: 'Manage high-volume campaigns with automated optimization tools. Do remarketing with Pixel tracking and custom audiences.' },
            { title: 'Excellent Customer Experience', description: 'Ensure continuous improvement with professional ad designs, A/B tests and automated reporting.' }
          ]
        },
        additionalFeatures: {
          title: 'Designed for maximum efficiency',
          subtitle: 'Increase your Meta campaign performance with our advanced features and automated workflows.'
        },
        faq: {
          title: 'Frequently Asked Questions',
          subtitle: 'The most frequently asked questions about Meta Ads',
          items: [
            { question: 'What is Meta Ads and how does it benefit my business?', answer: 'Meta Ads allows you to show your ads on Facebook, Instagram and WhatsApp. You can reach a wide audience with access to 4.2 billion users.' },
            { question: 'On which platforms can I advertise?', answer: 'You can advertise on Facebook, Instagram, Messenger and WhatsApp. You can manage all platforms from a single panel.' },
            { question: 'What should be the minimum budget?', answer: 'We recommend starting with a monthly minimum budget of 3,000 TL for Meta Ads. This may vary depending on your goals.' },
            { question: 'What are the targeting options?', answer: 'You can use demographic targeting, interests, behavioral targeting, lookalike audiences and custom audiences.' },
            { question: 'How do I track campaign results?', answer: 'We provide detailed analytics and conversion tracking with Meta Business Suite and Facebook Pixel. You monitor performance with monthly reports.' }
          ]
        }
      },
      socialMedia: {
        tag: 'Social Media',
        title: 'Social Media Management',
        description: 'Build a strong presence on social media platforms, grow your community and create brand loyalty.',
        features: [
          { title: 'Content Strategy', description: 'Engagement-focused content planning suitable for your target audience' },
          { title: 'Community Management', description: 'Interaction with your followers and community building' },
          { title: 'Growth Strategy', description: 'Organic and paid growth tactics' },
          { title: 'Engagement Increase', description: 'Maximizing engagement rates' },
          { title: 'Brand Awareness', description: 'Creating visibility and brand awareness' },
          { title: 'Influencer Collaborations', description: 'Managing effective influencer campaigns' }
        ],
        mockupCard: {
          managerName: 'Alex Fisher',
          managerTitle: 'Social Media Manager',
          title: 'Content Strategy',
          description: 'Build your community with engaging content.',
          details: {
            duration: '30 mins',
            timeSlots: ['15m', '30m', '45m', '1h'],
            meeting: 'Zoom',
            timezone: 'Europe/Istanbul'
          },
          stats: {
            followers: 'Followers',
            engagement: 'Engagement',
            posts: 'Posts/mo'
          }
        },
        keyBenefits: {
          title: 'How we grow your business with social media',
          subtitle: 'Increase your brand awareness with strong content strategies and community management.',
          benefits: [
            { title: 'Content Strategy', description: 'Create engagement-focused content suitable for your target audience. Increase your brand visibility with consistent posting schedules.' },
            { title: 'Community Management', description: 'Interact with your followers, manage comments and build a loyal community.' },
            { title: 'Performance Analysis', description: 'Continuously improve your strategy with detailed reporting and analytics.' }
          ]
        },
        additionalFeatures: {
          title: 'Designed for maximum efficiency',
          subtitle: 'Increase your social media performance with our advanced features.'
        },
        faq: {
          title: 'Frequently Asked Questions',
          subtitle: 'The most frequently asked questions about social media management',
          items: [
            { question: 'What is social media management?', answer: 'Social media management is strategically managing your brand\'s presence on social platforms.' },
            { question: 'On which platforms do you provide services?', answer: 'We provide services on Instagram, Facebook, LinkedIn, Twitter, TikTok and Pinterest platforms.' },
            { question: 'How often are content shared?', answer: 'We recommend 3-5 posts per week depending on your strategy.' },
            { question: 'What is community management?', answer: 'Community management is interacting with your followers, responding to comments and creating brand loyalty.' },
            { question: 'How is performance measured?', answer: 'We provide metrics such as engagement rates, reach, follower growth with detailed reports.' }
          ]
        }
      },
      webDesign: {
        tag: 'Web Design',
        title: 'Website Design',
        description: 'Strengthen your digital presence with modern, fast and conversion-focused websites.',
        features: [
          { title: 'Responsive Design', description: 'Perfect appearance on all devices' },
          { title: 'Fast Loading', description: 'Optimized performance' },
          { title: 'SEO Friendly', description: 'Optimized for search engines' },
          { title: 'Secure Infrastructure', description: 'SSL certificate and security' },
          { title: 'Modern Design', description: 'Current design trends' },
          { title: 'Mobile First', description: 'Mobile-first approach' }
        ],
        portfolioSection: {
          badge: 'Portfolio',
          title: 'Our Reference Websites',
          subtitle: 'Websites we designed for successful businesses. Each project was developed with a user experience and conversion-focused approach.'
        },
        portfolioSites: [
          { name: 'SmartIQ', description: 'Profit-focused digital solutions for automotive businesses', url: 'http://smartiq.io/' },
          { name: 'MCD Bag', description: 'Premium baby bags and accessories', url: 'https://mcdbag.com/' },
          { name: 'Veela', description: 'Skincare and haircare cosmetic brand', url: 'https://veela.com.tr/' },
          { name: 'TasarlaBas', description: 'Creative design solutions and services', url: 'https://tasarlabas.com/' },
          { name: 'Daphne Sandals', description: 'Premium shoe and sandal collection', url: 'https://daphnesandals.com/' },
          { name: 'Cheesecake Istanbul', description: 'Delicious cheesecake and dessert varieties', url: 'https://cheesecakeistanbul.com/' },
          { name: 'Firuze Showroom', description: 'Modern women\'s clothing and fashion products', url: 'https://firuzeshowroom.com/' },
          { name: 'Dore Hareket Eğitimi', description: 'Movement training and consulting services', url: 'https://dorehareketegitimi.com/' }
        ],
        visitButton: 'Visit',
        keyBenefits: {
          title: 'How we grow your business with web design',
          subtitle: 'Strengthen your digital presence with modern, fast and conversion-focused websites.',
          benefits: [
            { title: 'Modern and Responsive Design', description: 'We design responsive websites that provide perfect appearance on all devices. We optimize user experience with a mobile-first approach.' },
            { title: 'Fast and Optimized Performance', description: 'We create SEO-friendly, fast-loading and secure websites. We ensure you rank high in search engines with Core Web Vitals optimization.' },
            { title: 'Conversion-Focused Design', description: 'We design websites that increase conversion rates by analyzing user behavior. We ensure continuous improvement with A/B tests and analytics.' }
          ]
        },
        additionalFeatures: {
          title: 'Comprehensive web design solutions',
          subtitle: 'We offer professional services for all your web design needs.'
        },
        faq: {
          title: 'Frequently Asked Questions',
          subtitle: 'The most frequently asked questions about website design',
          items: [
            { question: 'How does the website design process work?', answer: 'We follow a comprehensive process consisting of needs analysis, design, development and testing phases. It takes an average of 4-8 weeks.' },
            { question: 'What technologies do you use?', answer: 'We use modern technologies such as React, Next.js, WordPress, Shopify. We choose the most suitable technology according to your project\'s needs.' },
            { question: 'Is SEO optimization included?', answer: 'Yes, all our websites are designed to be SEO-friendly and optimized for search engines.' },
            { question: 'Do you provide website maintenance and update services?', answer: 'Yes, we offer regular maintenance and update services to keep your website up to date.' },
            { question: 'Is mobile compatibility guaranteed?', answer: 'Yes, all our websites are designed with a mobile-first approach and provide perfect appearance on all devices.' }
          ]
        }
      },
      seoGeo: {
        tag: 'SEO & GEO',
        title: 'SEO & GEO Management',
        description: 'Rank at the top of search engines. Guarantee your digital success with organic traffic and visibility growth.',
        features: [
          { title: 'Keyword Research', description: 'Find the most effective keywords and analyze your competitors' },
          { title: 'SEO Optimization', description: 'Rank at the top with technical and content-focused SEO' },
          { title: 'Local SEO', description: 'Become visible in local searches with Google My Business optimization' },
          { title: 'Detailed Analysis', description: 'Track performance metrics and capture improvement opportunities' },
          { title: 'Quick Results', description: 'Significantly increase your visibility within 3-6 months' },
          { title: 'Safe Methods', description: 'Achieve lasting and sustainable success with white hat SEO techniques' }
        ],
        keyBenefits: {
          title: 'How we grow your business with SEO & GEO',
          subtitle: 'Achieve sustainable growth with organic visibility and local search optimization.',
          benefits: [
            { title: 'Organic Traffic Growth', description: 'Increase your organic visitors by ranking at the top of search engines and strengthen your digital presence in a cost-effective way.' },
            { title: 'Local Visibility', description: 'Reach your local customers most easily with Google My Business optimization and local SEO strategies.' },
            { title: 'Long-term Success', description: 'Achieve lasting results with white hat SEO techniques and grow your online presence safely.' }
          ]
        },
        additionalFeatures: {
          title: 'All SEO & GEO tools',
          subtitle: 'Strengthen your digital presence with comprehensive SEO and GEO solutions.'
        },
        faq: {
          title: 'Frequently Asked Questions',
          subtitle: 'The most frequently asked questions about SEO & GEO',
          items: [
            { question: 'When do SEO results become visible?', answer: 'SEO results typically begin to appear within 3-6 months. Technical adjustments and speed improvements are completed within the first month. After 3 months, organic traffic increases, and after 6 months, top-ranking visibility begins.' },
            { question: 'Why is Local SEO important?', answer: 'Local SEO enables local businesses to be visible in Google Maps and "near me..." searches. It is a critical tool for reaching local customers and is essential for physical businesses.' },
            { question: 'What do monthly SEO reports include?', answer: 'Our monthly reports include organic traffic trends, keyword positions, backlink gains, technical SEO metrics, Google My Business performance and improvement recommendations.' },
            { question: 'What is the difference between SEO and Google Ads?', answer: 'SEO works for organic (free) results, while Google Ads are paid advertisements. SEO provides long-term and lasting results, while Google Ads offers immediate visibility. The ideal strategy is to use both together.' }
          ]
        }
      },
      appDevelopment: {
        tag: 'App Development',
        title: 'Mobile & Web Application Development',
        description: 'Gain a competitive advantage in the digital world with custom mobile and web applications for your business.',
        features: [
          { title: 'Native Mobile Applications', description: 'High-performance native applications for iOS and Android' },
          { title: 'Web Applications', description: 'Responsive web applications with modern technologies' },
          { title: 'Cross-Platform', description: 'React Native ve Flutter ile tek kod tabanı' },
          { title: 'UI/UX Tasarım', description: 'Kullanıcı odaklı modern arayüz tasarımları' },
          { title: 'API Entegrasyonu', description: 'Üçüncü parti servislerle entegrasyon' },
          { title: 'Bakım & Destek', description: 'Sürekli güncelleme ve teknik destek' }
        ],
        keyBenefits: {
          title: 'How we grow your business with application development',
          subtitle: 'Realize your digital transformation with custom applications and increase customer experience.',
          benefits: [
            { title: 'Custom Solutions', description: 'Increase your operational efficiency with mobile and web applications designed specifically for your business needs.' },
            { title: 'Modern Technologies', description: 'We develop fast, secure and scalable applications with current technologies such as React Native, Flutter, Node.js.' },
            { title: 'Continuous Support', description: 'We offer regular updates, maintenance and technical support services to keep your application up to date.' }
          ]
        },
        additionalFeatures: {
          title: 'Comprehensive application development solutions',
          subtitle: 'We offer professional services for all your application development needs.'
        },
        faq: {
          title: 'Frequently Asked Questions',
          subtitle: 'The most frequently asked questions about application development',
          items: [
            { question: 'How does the mobile application development process work?', answer: 'We follow a comprehensive process consisting of needs analysis, design, development, testing and publishing phases. It takes an average of 3-6 months.' },
            { question: 'What technologies do you use?', answer: 'We use modern technologies such as React Native, Flutter, Swift, Kotlin, Node.js, React, Next.js. We choose the most suitable technology according to your project\'s needs.' },
            { question: 'Native or cross-platform?', answer: 'Both options are evaluated according to their advantages. Native applications offer higher performance, while cross-platform offers faster development and lower cost.' },
            { question: 'Do you provide application maintenance services?', answer: 'Yes, we offer regular update, maintenance and technical support services to keep your application up to date.' },
            { question: 'Is App Store and Google Play upload included?', answer: 'Yes, we manage the process of uploading and publishing your application to the App Store and Google Play.' }
          ]
        }
      },
      marketplace: {
        tag: 'Marketplace',
        title: 'Marketplace Consulting',
        description: 'Optimize your sales strategies on marketplaces like Trendyol, Amazon and maximize your revenue.',
        features: [
          { title: 'Marketplace Strategy', description: 'Right marketplace selection and sales strategy development' },
          { title: 'Product Optimization', description: 'Optimizing product listings, titles and descriptions' },
          { title: 'Pricing Strategy', description: 'Competitive pricing and promotion planning' },
          { title: 'Inventory Management', description: 'Stock tracking and supply chain optimization' },
          { title: 'Customer Service', description: 'Marketplace customer support and review management' },
          { title: 'Performance Analysis', description: 'Sales metrics and reporting' }
        ],
        keyBenefits: {
          title: 'How we grow your business with marketplace consulting',
          subtitle: 'Optimize your sales strategies on marketplaces like Trendyol, Amazon, Hepsiburada and increase your sales.',
          benefits: [
            { title: 'Marketplace Strategy', description: 'Increase your market share with the right marketplace selection and sales strategy development. Succeed on platforms like Trendyol, Amazon, Hepsiburada.' },
            { title: 'Product Optimization', description: 'Increase your visibility and sales by optimizing product listings, titles, descriptions and images.' },
            { title: 'Performance Management', description: 'Continuously improve your marketplace performance with sales metrics, inventory management and customer service.' }
          ]
        },
        additionalFeatures: {
          title: 'Comprehensive marketplace solutions',
          subtitle: 'We offer professional consulting services for all your marketplace needs.'
        },
        faq: {
          title: 'Frequently Asked Questions',
          subtitle: 'The most frequently asked questions about marketplace consulting',
          items: [
            { question: 'Which marketplaces do you serve?', answer: 'We serve all major marketplaces including Trendyol, Amazon, Hepsiburada, GittiGidiyor, N11.' },
            { question: 'How is marketplace sales strategy developed?', answer: 'We develop a comprehensive strategy in areas such as market analysis, product optimization, pricing strategy, inventory management and customer service.' },
            { question: 'What are marketplace commission rates?', answer: 'Commission rates vary by marketplace. Generally 8-15% commission is charged. Contact us for detailed information.' },
            { question: 'How is inventory management done?', answer: 'We optimize your inventory management with stock tracking, supply chain optimization and automatic notifications.' },
            { question: 'What do marketplace performance reports include?', answer: 'Our monthly reports include sales trends, product performance, customer reviews, stock status and improvement recommendations.' }
          ]
        }
      },
      mentorluk: {
        tag: 'Mentorship',
        title: 'Digital Marketing Mentorship',
        description: 'Develop your digital marketing skills, optimize your strategies and take your business to the next level with one-on-one consulting from our expert mentors.',
        features: [
          { title: 'One-on-One Mentorship Sessions', description: 'Develop your strategies with one-on-one meetings with our expert mentors' },
          { title: 'Personalized Strategies', description: 'Create digital marketing strategies and roadmaps specific to your business' },
          { title: 'Goal Setting and Tracking', description: 'Set clear goals and measure your progress with regular tracking' },
          { title: 'Hands-on Training', description: 'Practice on real projects in addition to theoretical knowledge' },
          { title: 'Continuous Support', description: 'Get instant answers to your questions and continuous guidance throughout the mentorship process' },
          { title: 'Performance Optimization', description: 'Analyze and optimize your existing campaigns' }
        ],
        services: [
          'Google Ads Mentorship',
          'Meta Ads Strategy Development',
          'SEO Optimization Guidance',
          'E-Commerce Strategies',
          'Social Media Management',
          'Content Marketing Planning',
          'Conversion Optimization',
          'Analytics and Reporting',
          'Marketplace Consulting',
          'Shopify Optimization'
        ],
        keyBenefits: {
          title: 'How we grow your business with mentorship',
          subtitle: 'Develop your digital marketing skills with expert guidance and take your business to the next level.',
          benefits: [
            { title: 'One-on-One Guidance', description: 'Develop your strategies with one-on-one meetings with our expert mentors. Reach your goals with personalized roadmaps.' },
            { title: 'Practical Experience', description: 'Gain experience by practicing on real projects in addition to theoretical knowledge. Analyze and optimize your existing campaigns.' },
            { title: 'Continuous Support', description: 'Get instant answers to your questions and continuous guidance throughout the mentorship process. Take your business to the next level.' }
          ]
        },
        additionalFeatures: {
          title: 'Comprehensive mentorship programs',
          subtitle: 'We offer expert guidance in all digital marketing areas.'
        },
        faq: {
          title: 'Frequently Asked Questions',
          subtitle: 'The most frequently asked questions about digital marketing mentorship',
          items: [
            { question: 'How does the mentorship program work?', answer: 'It is a comprehensive program that includes one-on-one meetings, personalized strategies, goal setting and tracking, hands-on training and continuous support.' },
            { question: 'What topics can I get mentorship on?', answer: 'We offer mentorship in all digital marketing areas such as Google Ads, Meta Ads, SEO, e-commerce, social media management, content marketing, conversion optimization and analytics.' },
            { question: 'How long do mentorship sessions last?', answer: 'Session duration varies according to your needs. Generally, 1-2 hour sessions are recommended. Weekly or monthly programs can be arranged.' },
            { question: 'Online or face-to-face?', answer: 'We offer both online and face-to-face mentorship sessions. You can choose the most suitable method according to your preference.' },
            { question: 'How long does the mentorship program last?', answer: 'Program duration varies according to your goals and needs. Generally, 3-6 month programs are recommended, but shorter or longer programs can also be arranged.' }
          ]
        }
      },
      shopify: {
        tag: 'Shopify',
        title: 'Shopify E-commerce',
        description: 'Set up your online store with Shopify and increase sales. Professional setup, design and optimization of your store.',
        features: [
          { title: 'Store Setup', description: 'Professional setup and configuration of Shopify' },
          { title: 'Custom Design', description: 'Brand-specific theme and design' },
          { title: 'Product Integration', description: 'Product loading and optimization' },
          { title: 'Payment Integration', description: 'Secure payment system integration' },
          { title: 'Shipping Integration', description: 'Integration of shipping companies and delivery options' },
          { title: 'Performance Optimization', description: 'Speed and conversion optimization' }
        ],
        mockupCard: {
          managerName: 'Samed Ordueri',
          managerTitle: 'Shopify Consultant',
          title: 'Shopify Store',
          description: 'Set up your online store professionally.',
          details: {
            duration: '30 mins',
            timeSlots: ['15d', '30d', '45d', '1h'],
            meeting: 'Google Meet',
            timezone: 'Europe/İstanbul'
          },
          stats: {
            roi: 'ROI',
            projects: 'Projects',
            support: 'Support'
          }
        },
        keyBenefits: {
          title: 'How we grow your business with Shopify',
          subtitle: 'Set up your online store professionally, optimize sales and grow your business.',
          benefits: [
            { title: 'Professional Setup', description: 'Set up your online store quickly with professional setup and configuration of Shopify.' },
            { title: 'Custom Design', description: 'Increase your brand presence with a custom theme and design. Improve conversion rates with a user-friendly interface.' },
            { title: 'Performance Optimization', description: 'Increase sales with optimization of speed, secure payment infrastructure and SEO strategies.' }
          ]
        },
        additionalFeatures: {
          title: 'Comprehensive Shopify solutions',
          subtitle: 'We offer professional services for all your Shopify needs.'
        },
        faq: {
          title: 'Frequently Asked Questions',
          subtitle: 'The most frequently asked questions about Shopify',
          items: [
            { question: 'What is Shopify?', answer: 'Shopify is a cloud-based e-commerce platform that allows you to create and manage your online store. It\'s the perfect platform for businesses of any size.' },
            { question: 'How much does Shopify cost?', answer: 'Shopify plans start at $29/month. Depending on your business needs, different packages are available.' },
            { question: 'How long does it take to set up a store?', answer: 'Setting up and launching a basic store takes about 2-4 weeks. For more complex projects, it may take longer.' },
            { question: 'Do you provide training on Shopify?', answer: 'Yes, we provide detailed training on using the Shopify admin panel, product management and settings.' },
            { question: 'Do you provide store maintenance services?', answer: 'Yes, we offer regular maintenance, updates and technical support services after launch.' }
          ]
        }
      },
    },
    // Home Page
    home: {
      hero: {
        newRelease: 'New Release',
        title: 'Your Trusted Partner in Digital Growth',
        description: 'We elevate your brand to the top in the digital world with data-driven strategies and proven methods. Accelerate your growth with ROI-focused solutions.',
        contactButton: 'Get in Touch',
        exploreServices: 'Explore Services',
        messages: [
          { title: 'Increase ROI with expert digital marketing solutions', description: 'We optimize your campaigns with data-driven strategies and proven methods. Increase your profits with Google Ads, Meta Ads and SEO.' },
          { title: 'Manage Google Ads like a pro', description: 'Increase your sales and reduce costs with our professional Google Ads management. Optimize ROAS.' },
          { title: 'Scale your brand with Meta Ads', description: 'Reach millions of users with effective ad campaigns on Facebook and Instagram. Increase conversions with targeted advertising.' },
          { title: 'Improve your website for search engines', description: 'Increase organic traffic and rank higher with our SEO services. Make your site visible to your target audience.' },
          { title: 'Boost sales with professional web design', description: 'Create a user-friendly website that converts visitors into customers. Increase conversions with modern, fast and responsive design.' }
        ]
      },
                  trustedBy: 'Fast-growing profitable companies in Turkey trust Thinklyze.',
      references: {
        title: 'Fast-growing brands trust Thinklyze.',
      },
      servicesSection: {
        title: 'Our Digital Marketing Services',
        subtitle: 'We deliver end-to-end solutions that strengthen your brand\'s digital presence.'
      },
      services: {
        googleAds: {
          title: 'Google Advertising',
          description: 'Increase your sales and strengthen your brand awareness. Use Google\'s power for your brand.',
          features: ['Google Ads Campaign Management', 'Keyword Optimization', 'ROI Tracking & Reporting'],
          price: '3,500₺',
          duration: 'Monthly',
          details: 'Details',
        },
        metaAds: {
          title: 'Meta Advertising',
          description: 'Reach your potential customers at the right moment. Effective ad campaigns on Facebook and Instagram.',
          features: ['Facebook & Instagram Ads', 'Audience Optimization', 'Creative & Video Design'],
          price: '3,000₺',
          duration: 'Monthly',
          details: 'Details',
        },
        socialMedia: {
          title: 'Social Media Management',
          description: 'Increase engagement and build a loyal customer base. Create a strong presence on social media.',
          features: ['Content Production & Planning', 'Community Management', 'Engagement Analysis'],
          price: '2,500₺',
          duration: 'Monthly',
          details: 'Details',
        },
        webDesign: {
          title: 'Web Design',
          description: 'Represent your digital presence in the best way. Modern, fast, and conversion-focused websites.',
          features: ['Modern & Responsive Design', 'SEO Optimization', 'Speed & Performance'],
          price: '8,000₺',
          duration: 'Project',
          details: 'Details',
        },
        seoGeo: {
          title: 'SEO & GEO',
          description: 'Rank at the top of search engines. Guarantee your digital success with organic traffic and visibility growth.',
          features: ['Keyword Research & Analysis', 'Technical SEO Optimization', 'Google Maps Optimization'],
          price: '4,500₺',
          duration: 'Monthly',
          details: 'Details',
        },
        appDevelopment: {
          title: 'App Development',
          description: 'Gain a competitive advantage in the digital world with custom mobile and web applications for your business.',
          features: ['iOS & Android Development', 'API Integration', 'Maintenance & Support'],
          price: '15,000₺',
          duration: 'Project',
          details: 'Details',
        },
        marketplace: {
          title: 'Marketplace Consulting',
          description: 'Optimize your sales strategies on marketplaces like Trendyol, Amazon and maximize your revenue.',
          features: ['Marketplace Strategy', 'Product Listing Optimization', 'Performance Reporting'],
          price: '4,000₺',
          duration: 'Monthly',
          details: 'Details',
        },
      },
      viewAllServices: 'View All Services',
      digitalExcellence: {
        teamBadge: '+15 expert team',
        title: 'Opening New Horizons in Digital Excellence',
        description: 'Join our journey of creating web pages with perfect details.',
        cta: 'Explore Features',
        stats: {
          conversion: 'Conversion Growth',
          customers: 'Satisfied Customers'
        },
        features: [
          { title: 'Pixel-Perfect', description: 'Start the journey of creating websites with perfect details.' },
          { title: 'Super Controls', description: 'Begin the journey of designing flawless perfect web pages.' },
          { title: 'Online Access', description: 'Move your business forward by attracting new customers across various platforms.' },
          { title: 'Easy to Use', description: 'Move your business forward by attracting customers across multiple platforms.' },
          { title: 'Advanced Tools', description: 'Grow your business with professional digital marketing tools.' },
          { title: '7/24 Support', description: 'Get continuous support and consultancy from our expert team.' }
        ]
      },
      advancedFeatures: {
        badge: 'Powerful Features',
        title: 'Capture the Future with Your Website',
        subtitle: 'Move your business forward by attracting customers on platforms.',
        sectionBadge: 'Advanced Features',
        sectionTitle: 'Make your website a real industry leader.',
        sectionDescription: 'Discover new frontiers of web design with tools that enable you to create visually impressive and technically solid digital experiences.',
        cta: 'Web Design Services',
        viewAllWebsites: 'View All Reference Websites'
      },
      marketingTools: {
        badge: 'Marketing Tools',
        title: 'Marketing Calculation Tools',
        description: 'Professional calculators for advertisers. Optimize your campaigns with ROAS, ROI, CPM and more.',
        cta: 'See All Calculators',
        moreToolsLabel: '+{count} more tools',
        categories: [
          {
            id: 'roas-roi',
            name: 'ROAS & ROI',
            description: 'Ad return and investment analytics',
            tools: ['E-Commerce Economics', 'ROAS Calculator', 'ROI Calculator', 'CPM Calculator'],
          },
          {
            id: 'influencer',
            name: 'Influencer Marketing',
            description: 'Influencer campaign metrics',
            tools: ['Engagement Rate', 'Influencer CPM'],
          },
          {
            id: 'budget',
            name: 'Budget Planning',
            description: 'Campaign budget optimization',
            tools: ['Daily Budget', 'Budget Allocation', 'Platform Split', 'ROI-Targeted Budget'],
          },
          {
            id: 'social',
            name: 'Social Media',
            description: 'Social media performance metrics',
            tools: ['Engagement Rate', 'Click-Through Rate (CTR)'],
          },
          {
            id: 'ecommerce',
            name: 'E-commerce KPI',
            description: 'E-commerce performance indicators',
            tools: ['LTV Calculator', 'CAC Calculator', 'LTV/CAC Ratio'],
          },
          {
            id: 'content',
            name: 'Content Analytics',
            description: 'Content performance measurements',
            tools: ['Content ROI', 'Conversion Rate'],
          },
        ],
      },
    },
    // About Page
    about: {
      badge: 'About Us',
      title: 'About Us',
      subtitle: 'Since 2019, we are a team that grows brands and produces result-oriented solutions in the field of digital marketing.',
      storyTitle: 'Our Story',
      storyParagraphs: [
        'Thinklyze was founded in 2019 with the vision of unlocking the potential of brands in the digital world. Our founding team\'s 10+ years of experience and passion for digital marketing form the foundation of where we are today.',
        'We started out as a small team, but grew rapidly thanks to our focus on customer success and the results we achieved. Every project is a new learning opportunity for us and a step towards excellence.',
        'Today, with our 150+ happy customers, we continue to be a reliable partner in the field of digital marketing, accompanying brands on their growth journey.'
      ],
      stats: {
        customers: 'Happy Customers',
        projects: 'Completed Projects',
        experience: 'Years Experience',
        roi: 'Average ROI Growth'
      },
      valuesTitle: 'Our Values',
      valuesSubtitle: 'The core values that shape the way we do business',
      values: [
        { title: 'Results Oriented', description: 'We work to achieve measurable results in every project.' },
        { title: 'Customer Satisfaction', description: 'The success of our customers is our greatest motivation.' },
        { title: 'Innovative Approach', description: 'We are a team that continuously learns and produces innovative solutions.' },
        { title: 'Reliability', description: 'We build trust with transparent communication and honest approach.' }
      ],
      missionTitle: 'Our Mission',
      missionSubtitle: 'Writing the success stories of brands in the digital world',
      mission: {
        badge: 'Our Vision',
        title: 'Pioneer of Digital Transformation',
        description: 'To be Turkey\'s most reliable and innovative agency in digital marketing and performance advertising. To add value to our customers with data-driven strategies and measurable results.',
        features: [
          'Develop data-driven strategies',
          'Provide measurable results',
          'Be a continuously learning and developing team',
          'Prioritize customer success'
        ]
      },
      milestones: [
        { year: '2019', title: 'Foundation', description: 'Thinklyze started to provide services in the field of digital marketing.' },
        { year: '2020', title: '50+ Customers', description: 'We served more than 50 customers in our first year.' },
        { year: '2021', title: 'Team Expansion', description: 'We expanded our expert team and increased our service quality.' },
        { year: '2022', title: '100+ Projects', description: 'We completed more than 100 successful projects.' },
        { year: '2023', title: 'Award', description: 'We received the Best Digital Marketing Agency award.' },
        { year: '2024', title: 'Growth', description: 'We continue to grow with 150+ active customers.' }
      ]
    },
    // Academy Page
    academy: {
      badge: 'Academy',
      title: 'Digital Marketing Academy',
      subtitle: 'Develop yourself in the field of digital marketing. Reach expert level with our video lessons.',
      videosSection: {
        badge: 'Our Video Lessons',
        title: 'Learn digital marketing',
        description: 'Develop your digital marketing skills with interactive video lessons prepared by our expert team.'
      }
    },
    // Marketing Tools Page
    marketingTools: {
      badge: 'Calculators',
      title: 'Marketing Calculation Tools',
      subtitle: 'Professional calculation tools to optimize your advertising campaigns. Easily calculate ROAS, ROI, CPM and more.',
      selectCategory: 'Select Category',
      ecommerceCalculator: {
        title: 'E-Commerce Economics Calculator',
        description: 'Analyze the profitability of your e-commerce business',
        inputs: {
          unitPrice: 'Unit Sales Price (₺)',
          unitCost: 'Sold Product Cost - COGS (₺)',
          vatRate: 'VAT Rate (%)',
          vatIncludedPrice: 'VAT Included Sales Price (₺)',
          wholesaleDepot: 'Wholesale Purchase + Depot Arrival (₺)',
          marketplaceCommission: 'Commission Rate (%)',
          marketplaceCommissionAmount: 'Commission Amount',
          paymentInfraCommission: 'Payment Infrastructure Commission Rate (%)',
          paymentInfraCommissionPlaceholder: 'Paytr, İyzico etc. For example 3.75',
          paymentInfraCost: 'Payment Infrastructure Cost (₺)',
          packagingCost: 'Packaging Cost (₺)',
          shippingCost: 'Shipping Cost (₺)',
          returnRate: 'Return Rate (%)',
          returnRateCost: 'Return Rate Cost (₺)',
          codExpenses: 'Total COD Expenses (₺)',
          cacTarget: 'CAC Target (₺)',
          netProfitTarget: 'Net Profit Target (₺)',
          adSpend: 'Ad Spend (₺)',
          totalOrders: 'Total Orders'
        },
        outputs: {
          revenue: 'Total Revenue (₺)',
          totalCosts: 'Total Costs (₺)',
          grossProfit: 'Gross Profit (₺)',
          netProfit: 'Net Profit (₺)',
          cac: 'Customer Acquisition Cost (CAC)',
          roas: 'ROAS',
          roasLabel: 'Minimum target 2.5',
          roi: 'ROI (%)',
          breakEvenRoas: 'Break-even ROAS',
          profitMargin: 'Profit Margin (%)',
          avgOrderCount: 'Customer Average Order Count',
          avgBasket: 'Basket Average (₺)',
          ltv: 'LTV (₺)',
          ltvCacRatio: 'LTV / CAC Ratio',
          netProfitPercent: 'Net Profit % (%)',
          grossProfitPercent: 'Gross Profit % (%)',
          cacFormula: 'Gross Profit - Net Profit',
          roasFormula: 'Revenue / CAC',
          roiFormula: 'Break-even',
          breakEvenFormula: 'Cannot calculate',
          breakEvenDescription: 'below loss, above profit',
          revenueCacDescription: 'Revenue: {revenue} ₺ / CAC: {cac} ₺'
        },
        vatNote: {
          title: 'VAT Note:',
          text: 'VAT, as it is a tax collected on behalf of the state: • It is not the profit of the business. • It is not included in profitability analyses, cost, and ROAS calculations.'
        },
        tabs: {
          ecommerceEconomics: 'E-Commerce Economics',
          roasCalculator: 'ROAS Calculator',
          roiCalculator: 'ROI Calculator',
          cpmCalculator: 'CPM Calculator'
        },
        warning: 'Note: Only green fields and VAT rate have been changed in calculations.',
        videoTitle: 'How to Calculate?',
        videoDescription: 'We explained in detail how e-commerce economics calculations are made in our video.'
      },
      buttons: {
        downloadPDF: 'Download PDF Report',
        shareResult: 'Share Result'
      },
      faq: {
        title: 'Frequently Asked Questions',
        subtitle: 'Answers to your questions about the E-Commerce Economics Calculator',
        items: [
          {
            question: 'What are ROI and ROAS? What is the difference between them?',
            answer: 'ROI (Return on Investment) is the return on investment rate and includes all costs. ROAS (Return on Ad Spend) only includes ad spend. ROI is expressed as a percentage (e.g., 250%), while ROAS is expressed as a ratio (e.g., 4:1). For detailed information, you can read our <a href=\'/blog/roi-nedir-nasil-hesaplanir-2025-rehberi\' class=\'text-blue-600 hover:text-blue-800 underline\'>ROI guide</a> and <a href=\'/blog/roas-nedir-nasil-hesaplanir-reklam-verimliligi-rehberi\' class=\'text-blue-600 hover:text-blue-800 underline\'>ROAS guide</a>.'
          },
          {
            question: 'What should the ROAS value be?',
            answer: 'The ROAS value varies depending on the industry and product profit margin. Generally, e-commerce businesses target ROAS values of 4:1 or higher. However, if the product profit margin is low, a higher ROAS may be required. The break-even point is 1:1, meaning it must be above this value.'
          },
          {
            question: 'How is CAC (Customer Acquisition Cost) calculated?',
            answer: 'In this calculator, CAC is automatically calculated using the Gross Profit - Net Profit formula. CAC is the total cost spent to acquire a customer. The lower the CAC value, the more profitable the business.'
          },
          {
            question: 'What is LTV (Lifetime Value)? How is it calculated?',
            answer: 'LTV is the total revenue a customer provides to the business over their lifetime. In this calculator, LTV is calculated using the Basket Average × Customer Average Order Count formula. An LTV/CAC ratio of 3:1 or higher is recommended.'
          },
          {
            question: 'Why is VAT not included in calculations?',
            answer: 'VAT is a tax collected on behalf of the state, so it is not the business\'s profit. Therefore, it is not included in profitability analysis, cost, and ROAS calculations. The calculator shows the VAT-inclusive sales price, but VAT is excluded from profit calculations.'
          },
          {
            question: 'How to download PDF report?',
            answer: 'Click the \'Download PDF Report\' button to download your calculation results as a PDF. The PDF includes logo, date, all calculation results, and page numbers. You can also use the \'Share Result\' button to share the PDF.'
          },
          {
            question: 'How can I share the calculation results?',
            answer: 'Click the \'Share Result\' button to share your calculation results. This button allows you to share the PDF report or copy the results as text. If Web Share API is supported, you can share it as a PDF file.'
          },
          {
            question: 'Which fields can be changed?',
            answer: 'In the calculator, only green fields and the VAT rate can be changed. Yellow fields are automatically calculated results and cannot be changed. The CAC value is also automatically calculated (Gross Profit - Net Profit) and cannot be changed.'
          },
          {
            question: 'What is Break-even ROAS?',
            answer: 'Break-even ROAS is the point where profit is zero. At this ROAS value, you neither profit nor lose. The Break-even ROAS value is the point where total costs equal revenue. You need to achieve ROAS above this value.'
          },
          {
            question: 'What metrics does this calculator calculate?',
            answer: 'This calculator calculates ROI, ROAS, LTV, CAC, Gross Profit, Net Profit, Break-even ROAS, and profit percentages. It also accounts for commission, payment infrastructure cost, shipping, packaging, and return costs.'
          }
        ]
      }
    },
    // References Page
    references: {
      title: 'Our References',
      subtitle: 'Brands we work with and our success stories',
      categories: {
        all: 'All',
        shoeBag: 'Shoes & Bags',
        babyKids: 'Baby & Kids',
        homeFurniture: 'Home & Furniture',
        food: 'Food',
        service: 'Service',
        personalCare: 'Personal Care',
        automotive: 'Automotive',
        outdoor: 'Outdoor',
        marketplace: 'Marketplace',
        healthMedical: 'Health & Medical',
        jewelry: 'Jewelry',
        textile: 'Textile & Modest Fashion',
        electronics: 'Electronics'
      }
    },
    // Testimonials
    testimonials: {
      tag: 'Testimonials',
      title: 'Don\'t just take our word for it',
      subtitle: 'Our users are our best ambassadors. Discover why we\'re the top choice for digital marketing.',
      reviewAll: 'Review all comments',
      items: [
        {
          quote: 'Working with Thinklyze completely transformed our business. Thanks to their data-driven approach, we achieved great success in our digital marketing strategy. The team is truly professional and results-oriented.',
          name: 'Ahmet Yılmaz',
          title: 'CEO, TechStart',
          avatar: 'AY'
        },
        {
          quote: 'The service we received from Thinklyze for our e-commerce store was truly excellent. Our ROI increased by 300% and our customer base expanded. Our Google Ads campaigns are now fully optimized.',
          name: 'Zeynep Demir',
          title: 'Founder, Fashion E-Commerce',
          avatar: 'ZD'
        },
        {
          quote: 'We found everything we were looking for in digital marketing at Thinklyze. They make a difference with their professional team and results-oriented approach. Our Meta ads are now much more effective.',
          name: 'Mehmet Kaya',
          title: 'Marketing Director, Global Inc',
          avatar: 'MK'
        },
        {
          quote: 'We worked with Thinklyze for SEO and performance optimization of our Shopify store. Our organic traffic increased 5x in 6 months. We got really impressive results.',
          name: 'Ayşe Özkan',
          title: 'Founder, TechStore',
          avatar: 'AÖ'
        },
        {
          quote: 'We received social media management support from Thinklyze. Our content quality improved, engagement rates increased, and our brand awareness developed significantly.',
          name: 'Can Yıldız',
          title: 'Brand Manager, FashionBrand',
          avatar: 'CY'
        },
        {
          quote: 'We received marketplace consulting services. Our sales on Trendyol and Hepsiburada increased by 400%. Product optimizations and pricing strategies were really successful.',
          name: 'Elif Şahin',
          title: 'E-Commerce Manager, RetailCo',
          avatar: 'EŞ'
        },
        {
          quote: 'Our UGC and influencer marketing campaigns were very successful thanks to Thinklyze. Our brand awareness reached wide audiences and our customer trust increased.',
          name: 'Burak Çelik',
          title: 'Founder, BeautyBrand',
          avatar: 'BÇ'
        },
        {
          quote: 'Our website design and development project was managed excellently by Thinklyze. We got a modern, fast, and conversion-focused site. Our customer satisfaction increased.',
          name: 'Deniz Kaya',
          title: 'CEO, ServiceCo',
          avatar: 'DK'
        },
        {
          quote: 'We worked with Thinklyze for our app development project. Both our iOS and Android apps were delivered on time and with quality. API integrations are working perfectly.',
          name: 'Gökhan Aydın',
          title: 'CTO, TechSolutions',
          avatar: 'GA'
        },
        {
          quote: 'Thanks to SEO and GEO services, we ranked high on Google. With local SEO strategies, the number of customers coming to our physical store increased significantly.',
          name: 'Selin Yılmaz',
          title: 'Marketing Manager, LocalBusiness',
          avatar: 'SY'
        }
      ]
    },
  },
  ru: {
    // Navigation
    nav: {
      home: 'Главная',
      services: 'Услуги',
      blog: 'Блог',
      academy: 'Академия',
      about: 'О нас',
      contact: 'Контакты',
      references: 'Референции',
      career: 'Карьера',
      glossary: 'Глоссарий',
      education: 'Образование',
      consulting: 'Почасовая консультация',
    },
    // Services
    services: {
      googleAds: 'Google Реклама',
      metaAds: 'Meta Реклама',
      socialMedia: 'Управление соцсетями',
      webDesign: 'Веб-дизайн',
      seoGeo: 'SEO & GEO',
      appDevelopment: 'Разработка приложений',
      marketplace: 'Консалтинг маркетплейсов',
      shopify: 'Shopify E-commerce',
      ugcInfluencer: 'UGC & Influencer Marketing',
      mentorship: 'Менторство',
      marketingTools: 'Калькуляторы',
    },
    // Common
    common: {
      getStarted: 'Начать',
      scheduleDemo: 'Запланировать демо',
      learnMore: 'Узнать больше',
      contactUs: 'Связаться с нами',
      readMore: 'Читать далее',
      faq: 'Часто задаваемые вопросы',
    },
    // Footer
    footer: {
      description: 'Выведите свой бизнес на новый уровень с нашей командой экспертов по цифровому маркетингу и performance рекламе.',
      quickLinks: 'Быстрые ссылки',
      services: 'Наши услуги',
      contact: 'Контакты',
      address: 'Zeytinlik Mah. Fişekhane Cad. Carousel No: 5 İç Kapı No: 17 Bakırköy/İstanbul',
      workingHours: 'Часы работы',
      weekdays: 'Понедельник - Пятница: 09:00 - 18:00',
      weekend: 'Суббота - Воскресенье: Закрыто',
      rights: 'Все права защищены.',
    },
    // Contact
    contact: {
      title: 'Контакты',
      subtitle: 'Свяжитесь с нами',
      description: 'Свяжитесь с нами, чтобы достичь ваших целей в области цифрового маркетинга. Наша команда экспертов готова предложить вам наиболее подходящее решение.',
      quoteFormTitle: 'Форма запроса предложения',
      quoteFormDescription: 'Пожалуйста, заполните форму ниже, чтобы мы могли предложить вам наиболее подходящее решение.',
      name: 'Имя Фамилия',
      namePlaceholder: 'Ваше имя и фамилия',
      email: 'Email',
      emailPlaceholder: 'example@email.com',
      phone: 'Телефон',
      phonePlaceholder: '+90 (5xx) xxx xx xx',
      company: 'Компания',
      companyPlaceholder: 'Название вашей компании',
      service: 'Интересующая услуга',
      selectService: 'Выберите услугу',
      budget: 'Диапазон бюджета',
      selectBudget: 'Выберите бюджет',
      message: 'Ваше сообщение',
      messagePlaceholder: 'Предоставьте подробную информацию о вашем проекте...',
      send: 'Отправить сообщение',
      sending: 'Отправка...',
      successTitle: 'Спасибо!',
      successMessage: 'Ваше сообщение успешно отправлено. Мы свяжемся с вами в ближайшее время.',
      ourOffice: 'Наш офис',
      openMap: 'Открыть на карте',
      address: 'Zeytinlik Mah. Fişekhane Cad. Carousel No: 5 İç Kapı No: 17',
      city: 'Bakırköy/İstanbul',
      faq: 'Часто задаваемые вопросы',
      faq1Question: 'Как долго ждать результатов?',
      faq1Answer: 'SEO-работы дают результаты через 3-6 месяцев, а кампании Google Ads начинают показывать результаты в течение 1-2 недель.',
      faq2Question: 'С какими отраслями вы работаете?',
      faq2Answer: 'Мы работаем со всеми отраслями, включая электронную коммерцию, технологии, здравоохранение, образование и финансы.',
      faq3Question: 'Как осуществляется отчетность?',
      faq3Answer: 'Мы предоставляем ежемесячные подробные отчеты о производительности и еженедельные сводные отчеты.',
      contactInfo: {
        email: {
          title: 'Email',
          details: 'info@thinklyze.com',
          description: 'Отвечаем в течение 24 часов',
        },
        phone: {
          title: 'Телефон',
          details: '0553 657 64 54',
          description: 'Понедельник - Пятница, 09:00 - 18:00',
        },
        address: {
          title: 'Адрес',
          details: 'Zeytinlik Mah. Fişekhane Cad. Carousel No: 5 İç Kapı No: 17',
          description: 'Bakırköy/İstanbul',
        },
        hours: {
          title: 'Часы работы',
          details: 'Понедельник - Пятница: 09:00 - 18:00',
          description: 'Мы к вашим услугам в будние дни',
        },
      },
      services: [
        'SEO Оптимизация',
        'Управление Google Ads',
        'Маркетинг в социальных сетях',
        'Контент-маркетинг',
        'Консультации по цифровому маркетингу',
        'Веб-аналитика',
        'Другое',
      ],
      budgetRanges: [
        '5,000₺ - 10,000₺',
        '10,000₺ - 25,000₺',
        '25,000₺ - 50,000₺',
        '50,000₺ - 100,000₺',
        '100,000₺+',
      ],
      formLabels: {
        name: 'Имя Фамилия',
        email: 'Email',
        phone: 'Телефон',
        company: 'Компания',
        service: 'Интересующая услуга',
        budget: 'Диапазон бюджета',
        message: 'Ваше сообщение',
      },
      notSpecified: 'Не указано',
      quoteRequestForm: 'Форма запроса предложения',
    },
    // Live Support
    liveSupport: {
      title: 'Живая поддержка',
      placeholder: 'Напишите ваше сообщение',
      welcome: 'Здравствуйте! Добро пожаловать в Thinklyze! 👋',
      help: 'Чем могу помочь? Могу ответить на ваши вопросы через WhatsApp.',
      responseTime: 'Обычно отвечаем в течение нескольких минут',
      continueWhatsApp: 'Продолжить в WhatsApp',
      secure: 'Безопасная и быстрая связь',
      placeholderText: 'Напишите ваше сообщение...',
    },
    // Callback Modal
    callback: {
      title: 'Как с вами связаться?',
      name: 'Имя Фамилия',
      namePlaceholder: 'Ваше имя и фамилия',
      email: 'Email',
      emailPlaceholder: 'Ваш email',
      phone: 'Телефон',
      phonePlaceholder: 'Ваш номер телефона',
      company: 'Название компании',
      companyPlaceholder: 'Название компании',
      ecommerce: 'Занимаетесь ли вы электронной коммерцией?',
      yes: 'Да',
      no: 'Нет',
      starting: 'Только начинаю',
      source: 'Где вы узнали о Thinklyze?',
      customer: 'От клиентов Thinklyze',
      callMe: 'Мы вам перезвоним',
    },
    // Service Descriptions
    serviceDescriptions: {
      googleAds: 'Кампании Google Ads и YouTube',
      metaAds: 'Реклама в Facebook и Instagram',
      socialMedia: 'Создание сообществ и управление контентом',
      webDesign: 'Современный и адаптивный веб-дизайн',
      seoGeo: 'Поисковая и локальная SEO оптимизация',
      appDevelopment: 'iOS, Android и веб-приложения',
      marketplace: 'Trendyol, Amazon и другие',
      shopify: 'Магазины электронной коммерции и оптимизация',
      ugcInfluencer: 'Пользовательский контент и сотрудничество с инфлюенсерами',
      mentorship: 'Менторство и консультации по цифровому маркетингу',
      marketingTools: 'ROAS, ROI, CPM и другие маркетинговые метрики',
    },
    // Service Pages
    servicePages: {
      common: {
        scheduleMeeting: 'Запланировать встречу',
        callMe: 'Мы вам перезвоним',
        trustedBy: 'Быстрорастущие бренды доверяют Thinklyze.',
        getStarted: 'Начать',
        keyBenefits: 'Ключевые преимущества',
        additionalFeatures: 'Дополнительные возможности',
        serviceScope: 'Объем наших услуг:',
      },
      ugcInfluencer: {
        tag: 'UGC & Influencer Marketing',
        title: 'UGC & Influencer Marketing',
        description: 'Повысьте узнаваемость бренда с помощью пользовательского контента и сотрудничества с инфлюенсерами, достигайте целевой аудитории и увеличивайте продажи.',
        features: [
          {
            title: 'Производство UGC контента',
            description: 'Завоюйте доверие к вашему бренду с помощью аутентичного контента, созданного реальными пользователями'
          },
          {
            title: 'Сотрудничество с инфлюенсерами',
            description: 'Установите стратегические партнерства с инфлюенсерами, подходящими для вашей целевой аудитории'
          },
          {
            title: 'Анализ целевой аудитории',
            description: 'Проведите детальный анализ для поиска правильных инфлюенсеров и создателей контента'
          },
          {
            title: 'Управление кампаниями',
            description: 'Управляйте и отслеживайте все ваши кампании с инфлюенсерами с единой платформы'
          },
          {
            title: 'Соответствие бренду',
            description: 'Выбирайте контент и инфлюенсеров в соответствии с ценностями вашего бренда'
          },
          {
            title: 'Анализ эффективности',
            description: 'Измеряйте эффективность кампании и максимизируйте ROI'
          }
        ],
        services: [
          'Производство и управление UGC контентом',
          'Сотрудничество с микро и макро инфлюенсерами',
          'Выбор и анализ инфлюенсеров',
          'Разработка контент-стратегии',
          'Планирование и управление кампаниями',
          'Отслеживание эффективности и отчетность',
          'Программы бренд-амбассадоров',
          'Кампании запуска продуктов',
          'Хэштег кампании',
          'Права на контент и юридическое соответствие'
        ],
        mockupCard: {
          title: 'Кампания с инфлюенсерами',
          subtitle: 'UGC & Контент-маркетинг',
          heading: 'Кампания узнаваемости бренда',
          description: 'Достигайте своей целевой аудитории с помощью аутентичного пользовательского контента и сотрудничества с инфлюенсерами.',
          metrics: {
            influencers: '50+ инфлюенсеров',
            content: '100+ UGC контента',
            reach: '5M+ охват',
            engagement: '500K+ вовлечение'
          },
          stats: {
            roi: 'ROI',
            projects: 'Проекты',
            support: 'Поддержка'
          }
        },
        keyBenefits: {
          title: 'Как мы развиваем ваш бренд с помощью UGC & Influencer Marketing',
          subtitle: 'Повышайте узнаваемость бренда и надежно достигайте целевой аудитории с помощью аутентичного контента и стратегических партнерств с инфлюенсерами.',
          benefits: [
            {
              title: 'Производство аутентичного контента',
              description: 'Завоюйте доверие к вашему бренду с помощью аутентичного контента, созданного реальными пользователями. Создавайте социальное доказательство с помощью UGC кампаний и увеличивайте конверсии.'
            },
            {
              title: 'Стратегические партнерства с инфлюенсерами',
              description: 'Установите стратегические партнерства с микро и макро инфлюенсерами, подходящими для вашей целевой аудитории. Создайте максимальный эффект с правильным выбором инфлюенсеров и управлением кампаниями.'
            },
            {
              title: 'Измеримые результаты',
              description: 'Отслеживайте все ваши кампании с помощью детального анализа и отчетности. Постоянно оптимизируйте свою эффективность с метриками ROI, охвата, вовлечения и конверсии.'
            }
          ]
        },
        additionalFeatures: {
          title: 'Мы предлагаем комплексные решения',
          subtitle: 'Развивайте свой бренд с нашими профессиональными услугами, охватывающими все аспекты UGC и Influencer Marketing.'
        },
        faq: {
          title: 'Часто задаваемые вопросы',
          subtitle: 'Наиболее часто задаваемые вопросы о UGC & Influencer Marketing',
          items: []
        }
      },
      googleAds: {
        tag: 'Google Ads',
        title: 'Управление Google Ads',
        description: 'Используйте мощь Google для вашего бренда. Достигайте нужных клиентов с таргетированной рекламой и увеличивайте продажи.',
        features: [
          { title: 'Таргетированные кампании', description: 'Достигайте нужной аудитории в нужное время с правильным сообщением' },
          { title: 'Оптимизация ROI', description: 'Максимальная отдача от каждого клика' },
          { title: 'Детальная аналитика', description: 'Отслеживайте эффективность кампании в реальном времени' },
          { title: 'Сегментация аудитории', description: 'Эффективный охват с демографическим и поведенческим таргетингом' },
          { title: 'Быстрые результаты', description: 'Начните видеть первые результаты в течение 24 часов' },
          { title: 'Безопасное управление', description: 'Безопасное управление кампаниями с сертифицированными специалистами Google Partner' }
        ],
        services: [
          'Настройка кампаний Google Ads',
          'Исследование и анализ ключевых слов',
          'Написание и оптимизация рекламных текстов',
          'Управление стратегией ставок',
          'Настройка отслеживания конверсий',
          'Управление A/B тестированием',
          'Оптимизация минус-слов',
          'Повышение показателя качества',
          'Анализ конкурентов',
          'Ежемесячные отчеты о производительности'
        ],
        mockupCard: {
          managerName: 'Samed Ordueri',
          managerTitle: 'Менеджер кампаний',
          title: 'Кампания Google Ads',
          description: 'Комплексная стратегия кампании для максимизации ROI.',
          details: {
            duration: '30 мин',
            timeSlots: ['15д', '30д', '45д', '1ч'],
            meeting: 'Google Meet',
            timezone: 'Europe/İstanbul'
          },
          stats: {
            roi: 'ROI',
            projects: 'Проекты',
            support: 'Поддержка'
          }
        },
        keyBenefits: {
          title: 'Как мы развиваем ваш бизнес с Google Ads',
          subtitle: 'Достигайте нужных клиентов с таргетированными кампаниями, увеличивайте конверсии и получайте конкурентное преимущество.',
          benefits: [
            { title: 'Таргетированные рекламные стратегии', description: 'Достигайте нужной аудитории в нужное время с Google Ads. Управляйте своими кампаниями с максимальной эффективностью с демографическим таргетингом, поведенческим анализом и оптимизацией ключевых слов.' },
            { title: 'Эффективное управление кампаниями', description: 'Легко управляйте кампаниями с большим объемом. Обеспечьте постоянную оптимизацию с A/B тестами, автоматическими стратегиями ставок и детальной отчетностью.' },
            { title: 'Выдающаяся производительность ROI', description: 'Предоставляйте отличный опыт своим клиентам с профессиональным управлением кампаниями, брендированными страницами отчетности и автоматическими уведомлениями, максимизируя возврат инвестиций.' }
          ]
        },
        additionalFeatures: {
          title: 'Разработано для максимальной эффективности',
          subtitle: 'Повышайте эффективность своих кампаний с нашими расширенными функциями и автоматизированными рабочими процессами.'
        },
        faq: {
          title: 'Часто задаваемые вопросы',
          subtitle: 'Наиболее часто задаваемые вопросы о Google Ads',
          items: [
            { question: 'Что такое Google Ads и как это приносит пользу моему бизнесу?', answer: 'Google Ads позволяет показывать ваши объявления в результатах поиска Google и на партнерских сайтах. С таргетированными кампаниями вы можете достичь нужных клиентов и увеличить продажи.' },
            { question: 'Как быстро кампания Google Ads дает результаты?', answer: 'Вы начнете видеть первые результаты в течение 24-48 часов. Однако для оптимизированных кампаний мы рекомендуем процесс 2-4 недели.' },
            { question: 'Каков минимальный бюджет?', answer: 'Это зависит от вашей отрасли и целей, но мы рекомендуем начинать с ежемесячного бюджета минимум 5000 ₺.' },
            { question: 'Как осуществляется управление кампаниями?', answer: 'Наша команда экспертов ежедневно отслеживает и оптимизирует ваши кампании, предоставляя ежемесячные детальные отчеты.' },
            { question: 'Как измеряется ROI?', answer: 'Мы отслеживаем все конверсии с Google Analytics и конверсионным трекингом, предоставляя детальные отчеты о ROI.' }
          ]
        }
      },
      metaAds: {
        tag: 'Meta Ads',
        title: 'Реклама Meta',
        description: 'Достигайте миллиардов пользователей в Facebook, Instagram и WhatsApp. Достигайте своих потенциальных клиентов в самый подходящий момент, самым эффективным способом.',
        features: [
          { title: 'Детальный таргетинг', description: 'Варианты таргетинга по демографии, интересам и поведению' },
          { title: 'Визуальная реклама', description: 'Привлекайте внимание с впечатляющими изображениями и видео' },
          { title: 'Реклама в Stories', description: 'Рассказывайте эффективные истории с полноэкранным опытом' },
          { title: 'Lookalike Audiences', description: 'Достигайте людей, похожих на ваших текущих клиентов' },
          { title: 'Кампании вовлечения', description: 'Создавайте сообщество с кампаниями, увеличивающими вовлечение' },
          { title: 'Ремаркетинг', description: 'Снова достигайте тех, кто посетил ваш сайт' }
        ],
        mockupCard: {
          managerName: 'Samed Ordueri',
          managerTitle: 'Менеджер кампаний',
          title: 'Кампания Meta Ads',
          description: 'Достигайте миллиардов пользователей в Facebook и Instagram.',
          details: {
            duration: '30 мин',
            timeSlots: ['15д', '30д', '45д', '1ч'],
            meeting: 'Zoom',
            timezone: 'Europe/İstanbul'
          },
          stats: {
            users: 'Пользователи',
            campaigns: 'Кампании',
            response: 'Ответ'
          }
        },
        keyBenefits: {
          title: 'Как мы развиваем ваш бизнес с Meta Ads',
          subtitle: 'Достигайте 4,2 миллиарда пользователей, увеличивайте конверсии с таргетированными кампаниями.',
          benefits: [
            { title: 'Расширенный таргетинг', description: 'Достигайте своих потенциальных клиентов с таргетингом по демографии, интересам и поведению в Facebook и Instagram.' },
            { title: 'Эффективные стратегии кампаний', description: 'Управляйте кампаниями с большим объемом с инструментами автоматической оптимизации. Проводите ремаркетинг с пиксельным отслеживанием и пользовательскими аудиториями.' },
            { title: 'Превосходный клиентский опыт', description: 'Обеспечьте постоянное улучшение с профессиональным дизайном рекламы, A/B тестами и автоматической отчетностью.' }
          ]
        },
        additionalFeatures: {
          title: 'Разработано для максимальной эффективности',
          subtitle: 'Повышайте эффективность своих Meta кампаний с нашими расширенными функциями и автоматизированными рабочими процессами.'
        },
        faq: {
          title: 'Часто задаваемые вопросы',
          subtitle: 'Наиболее часто задаваемые вопросы о Meta Ads',
          items: [
            { question: 'Что такое Meta Ads и как это приносит пользу моему бизнесу?', answer: 'Meta Ads позволяет показывать ваши объявления в Facebook, Instagram и WhatsApp. С охватом 4,2 миллиарда пользователей вы можете достичь широкой аудитории.' },
            { question: 'На каких платформах я могу рекламироваться?', answer: 'Вы можете рекламироваться в Facebook, Instagram, Messenger и WhatsApp. Вы можете управлять всеми платформами с одной панели.' },
            { question: 'Каков минимальный бюджет?', answer: 'Для Meta Ads мы рекомендуем начинать с ежемесячного бюджета минимум 3000 ₺. Это может варьироваться в зависимости от ваших целей.' },
            { question: 'Какие варианты таргетинга?', answer: 'Вы можете использовать демографический таргетинг, интересы, таргетинг по поведению, похожие аудитории и пользовательские аудитории.' },
            { question: 'Как я отслеживаю результаты кампании?', answer: 'Мы предоставляем детальную аналитику и отслеживание конверсий с Meta Business Suite и Facebook Pixel. Вы отслеживаете производительность с ежемесячными отчетами.' }
          ]
        }
      },
      socialMedia: {
        tag: 'Social Media',
        title: 'Управление социальными сетями',
        description: 'Создайте сильное присутствие на платформах социальных сетей, развивайте сообщество и создавайте лояльность к бренду.',
        features: [
          { title: 'Контент-стратегия', description: 'Планирование контента, ориентированного на взаимодействие, подходящего для вашей целевой аудитории' },
          { title: 'Управление сообществом', description: 'Взаимодействие с вашими подписчиками и создание сообщества' },
          { title: 'Стратегия роста', description: 'Органическая и платная тактика роста' },
          { title: 'Увеличение вовлечения', description: 'Максимизация показателей вовлечения' },
          { title: 'Узнаваемость бренда', description: 'Создание видимости и осведомленности о бренде' },
          { title: 'Сотрудничество с инфлюенсерами', description: 'Управление эффективными кампаниями с инфлюенсерами' }
        ],
        mockupCard: {
          managerName: 'Samed Ordueri',
          managerTitle: 'Менеджер социальных сетей',
          title: 'Контент-стратегия',
          description: 'Создайте свое сообщество с интерактивным контентом.',
          details: {
            duration: '30 мин',
            timeSlots: ['15д', '30д', '45д', '1ч'],
            meeting: 'Zoom',
            timezone: 'Europe/İstanbul'
          },
          stats: {
            followers: 'Подписчики',
            engagement: 'Вовлечение',
            posts: 'Посты/мес'
          }
        },
        keyBenefits: {
          title: 'Как мы развиваем ваш бизнес с социальными сетями',
          subtitle: 'Повышайте узнаваемость бренда с мощными контент-стратегиями и управлением сообществом.',
          benefits: [
            { title: 'Контент-стратегия', description: 'Создавайте контент, ориентированный на взаимодействие, подходящий для вашей целевой аудитории. Увеличивайте видимость бренда с последовательными календарями публикаций.' },
            { title: 'Управление сообществом', description: 'Взаимодействуйте с вашими подписчиками, управляйте комментариями и создайте лояльное сообщество.' },
            { title: 'Анализ производительности', description: 'Постоянно улучшайте свою стратегию с детальной отчетностью и аналитикой.' }
          ]
        },
        additionalFeatures: {
          title: 'Разработано для максимальной эффективности',
          subtitle: 'Повышайте эффективность социальных сетей с нашими расширенными функциями.'
        },
        faq: {
          title: 'Часто задаваемые вопросы',
          subtitle: 'Наиболее часто задаваемые вопросы об управлении социальными сетями',
          items: [
            { question: 'Какие платформы социальных сетей вы управляете?', answer: 'Мы предоставляем услуги по управлению Instagram, Facebook, Twitter, LinkedIn, TikTok и YouTube.' },
            { question: 'Как часто публикуется контент?', answer: 'В зависимости от вашего пакета, мы публикуем 3-5 постов в неделю. Частота публикации может быть настроена в соответствии с вашими потребностями.' },
            { question: 'Кто создает контент?', answer: 'Наша профессиональная команда создателей контента готовит визуальный и письменный контент специально для вашего бренда.' },
            { question: 'Как управляются комментарии и сообщения?', answer: 'Мы отслеживаем и отвечаем на комментарии и сообщения в рабочее время. Срочные случаи обрабатываются немедленно.' },
            { question: 'Как отслеживается производительность?', answer: 'Мы отслеживаем производительность с детальными аналитическими отчетами и делимся результатами ежемесячно.' }
          ]
        }
      },
      webDesign: {
        tag: 'Web Design',
        title: 'Веб-дизайн',
        description: 'Представьте свое цифровое присутствие наилучшим образом. Современные, быстрые и ориентированные на конверсию веб-сайты.',
        features: [
          { title: 'Современный дизайн', description: 'Эстетичный и пользовательский дизайн' },
          { title: 'Адаптивный', description: 'Идеальная работа на всех устройствах' },
          { title: 'Быстрая загрузка', description: 'Оптимизированная производительность и скорость' },
          { title: 'SEO-дружественный', description: 'Структура, оптимизированная для поисковых систем' },
          { title: 'Безопасность', description: 'SSL-сертификат и защита безопасности' },
          { title: 'Поддержка', description: 'Техническая поддержка и обновления' }
        ],
        portfolioSection: {
          badge: 'Портфолио',
          title: 'Наши сайты из портфолио',
          subtitle: 'Сайты, которые мы разработали для успешных предприятий. Каждый проект был разработан с акцентом на пользовательский опыт и конверсию.'
        },
        portfolioSites: [
          { name: 'SmartIQ', description: 'Цифровые решения для автомобильного бизнеса, ориентированные на прибыль', url: 'http://smartiq.io/' },
          { name: 'MCD Bag', description: 'Премиальные детские сумки и аксессуары', url: 'https://mcdbag.com/' },
          { name: 'Veela', description: 'Косметический бренд по уходу за кожей и волосами', url: 'https://veela.com.tr/' },
          { name: 'TasarlaBas', description: 'Креативные дизайнерские решения и услуги', url: 'https://tasarlabas.com/' },
          { name: 'Daphne Sandals', description: 'Премиальная коллекция обуви и сандалий', url: 'https://daphnesandals.com/' },
          { name: 'Cheesecake Istanbul', description: 'Вкусный чизкейк и разнообразие десертов', url: 'https://cheesecakeistanbul.com/' },
          { name: 'Firuze Showroom', description: 'Современная женская одежда и модные товары', url: 'https://firuzeshowroom.com/' },
          { name: 'Dore Hareket Eğitimi', description: 'Тренинг движения и консалтинговые услуги', url: 'https://dorehareketegitimi.com/' }
        ],
        visitButton: 'Посетить',
        keyBenefits: {
          title: 'Как мы развиваем ваш бизнес с веб-дизайном',
          subtitle: 'Усиливайте свое цифровое присутствие с современными, быстрыми и ориентированными на конверсию веб-сайтами.',
          benefits: [
            { title: 'Современный дизайн', description: 'Создавайте профессиональное цифровое присутствие с современным и эстетичным дизайном. Увеличивайте доверие клиентов и конверсии.' },
            { title: 'Адаптивный и быстрый', description: 'Обеспечьте идеальную работу на всех устройствах. Повышайте удовлетворенность пользователей с быстрой загрузкой.' },
            { title: 'SEO-оптимизация', description: 'Занимайте верхние позиции в поисковых системах. Увеличивайте органический трафик с SEO-дружественной структурой.' }
          ]
        },
        additionalFeatures: {
          title: 'Комплексные решения веб-дизайна',
          subtitle: 'Создайте профессиональное цифровое присутствие с нашими профессиональными услугами.'
        },
        faq: {
          title: 'Часто задаваемые вопросы',
          subtitle: 'Наиболее часто задаваемые вопросы о веб-дизайне',
          items: [
            { question: 'Сколько времени занимает процесс веб-дизайна?', answer: 'В зависимости от сложности и объема проекта, процесс занимает в среднем 4-8 недель.' },
            { question: 'Является ли веб-сайт адаптивным?', answer: 'Да, все наши веб-сайты полностью адаптивны и идеально работают на мобильных, планшетах и настольных устройствах.' },
            { question: 'Включена ли SEO-оптимизация?', answer: 'Да, основная SEO-оптимизация (структура, мета-теги, скорость) включена в процесс проектирования.' },
            { question: 'Предоставляется ли управление контентом?', answer: 'Да, мы интегрируем простую в использовании панель управления контентом (CMS), где вы можете обновлять свой контент.' },
            { question: 'Предоставляется ли поддержка после дизайна?', answer: 'Да, мы предоставляем техническую поддержку, обновления и услуги по обслуживанию после проекта.' }
          ]
        }
      },
      seoGeo: {
        tag: 'SEO & GEO',
        title: 'SEO & GEO',
        description: 'Занимайте верхние позиции в поисковых системах. Гарантируйте свой цифровой успех с увеличением органического трафика и видимости.',
        features: [
          { title: 'Исследование ключевых слов', description: 'Анализ правильных ключевых слов и стратегия' },
          { title: 'Техническое SEO', description: 'Техническая оптимизация веб-сайта' },
          { title: 'Контент-оптимизация', description: 'SEO-дружественное создание контента' },
          { title: 'Создание ссылок', description: 'Стратегии качественных обратных ссылок' },
          { title: 'Локальное SEO', description: 'Оптимизация Google Maps' },
          { title: 'Анализ конкурентов', description: 'Анализ конкурентов и стратегии' }
        ],
        services: [
          'Анализ и исследование ключевых слов',
          'Аудит технического SEO',
          'Оптимизация контента',
          'Создание обратных ссылок',
          'Локальная SEO-оптимизация',
          'Оптимизация Google My Business',
          'Анализ конкурентов',
          'Аудит SEO',
          'Мониторинг рейтинга',
          'Ежемесячная отчетность о производительности'
        ],
        keyBenefits: {
          title: 'Как мы развиваем ваш бизнес с SEO & GEO',
          subtitle: 'Увеличивайте органический трафик, занимайте верхние позиции в поисковых системах и усиливайте свое локальное присутствие.',
          benefits: [
            { title: 'Исследование ключевых слов', description: 'Достигайте правильной аудитории, нацеливаясь на правильные ключевые слова. Увеличивайте органический трафик и конверсии.' },
            { title: 'Техническая оптимизация', description: 'Сделайте свой веб-сайт более видимым для поисковых систем с технической SEO-оптимизацией. Повышайте скорость и удобство использования.' },
            { title: 'Локальное SEO', description: 'Усиливайте свое локальное присутствие с оптимизацией Google Maps. Достигайте большего количества локальных клиентов.' }
          ]
        },
        additionalFeatures: {
          title: 'Комплексные решения SEO',
          subtitle: 'Занимайте верхние позиции в поисковых системах с нашими профессиональными услугами SEO.'
        },
        faq: {
          title: 'Часто задаваемые вопросы',
          subtitle: 'Наиболее часто задаваемые вопросы о SEO & GEO',
          items: [
            { question: 'Что такое SEO и почему это важно?', answer: 'SEO — это процесс оптимизации вашего веб-сайта для занятия верхних позиций в поисковых системах. Это важно для увеличения органического трафика и конверсий.' },
            { question: 'Как быстро SEO дает результаты?', answer: 'SEO — это долгосрочная стратегия. Вы начнете видеть заметные результаты в течение 3-6 месяцев.' },
            { question: 'Что такое локальное SEO?', answer: 'Локальное SEO — это процесс оптимизации вашего бизнеса для локальных поисков. Оно включает оптимизацию Google Maps и локальных бизнес-листингов.' },
            { question: 'Как измеряется производительность SEO?', answer: 'Производительность SEO измеряется с помощью метрик, таких как органический трафик, рейтинг ключевых слов, конверсии и обратные ссылки.' },
            { question: 'Нужно ли постоянное SEO?', answer: 'Да, SEO — это непрерывный процесс. Важно постоянно оптимизировать ваш веб-сайт из-за алгоритмических изменений поисковых систем и конкуренции.' }
          ]
        }
      },
      appDevelopment: {
        tag: 'App Development',
        title: 'Разработка приложений',
        description: 'Получите конкурентное преимущество в цифровом мире с индивидуальными мобильными и веб-приложениями для вашего бизнеса.',
        features: [
          { title: 'iOS & Android', description: 'Нативная разработка мобильных приложений' },
          { title: 'Кроссплатформенное', description: 'React Native, Flutter' },
          { title: 'Веб-приложения', description: 'React, Next.js, Node.js' },
          { title: 'API-интеграция', description: 'RESTful API, GraphQL' },
          { title: 'База данных', description: 'MongoDB, PostgreSQL, MySQL' },
          { title: 'Облачные сервисы', description: 'AWS, Google Cloud, Azure' }
        ],
        keyBenefits: {
          title: 'Как мы развиваем ваш бизнес с разработкой приложений',
          subtitle: 'Реализуйте свою цифровую трансформацию с индивидуальными приложениями и повысьте клиентский опыт.',
          benefits: [
            { title: 'Пользовательские решения', description: 'Повышайте свою операционную эффективность с мобильными и веб-приложениями, специально разработанными для нужд вашего бизнеса.' },
            { title: 'Современные технологии', description: 'Мы разрабатываем быстрые, безопасные и масштабируемые приложения с современными технологиями, такими как React Native, Flutter, Node.js.' },
            { title: 'Постоянная поддержка', description: 'Мы предлагаем регулярные обновления, обслуживание и услуги технической поддержки, чтобы ваше приложение оставалось актуальным.' }
          ]
        },
        additionalFeatures: {
          title: 'Комплексные решения для разработки приложений',
          subtitle: 'Мы предлагаем профессиональные услуги для всех ваших потребностей в разработке приложений.'
        },
        faq: {
          title: 'Frequently Asked Questions',
          subtitle: 'The most frequently asked questions about application development',
          items: [
            { question: 'How does the mobile application development process work?', answer: 'We follow a comprehensive process consisting of needs analysis, design, development, testing and publishing phases. It takes an average of 3-6 months.' },
            { question: 'What technologies do you use?', answer: 'We use modern technologies such as React Native, Flutter, Swift, Kotlin, Node.js, React, Next.js. We choose the most suitable technology according to your project\'s needs.' },
            { question: 'Native or cross-platform?', answer: 'Both options are evaluated according to their advantages. Native applications offer higher performance, while cross-platform offers faster development and lower cost.' },
            { question: 'Do you provide application maintenance services?', answer: 'Yes, we offer regular update, maintenance and technical support services to keep your application up to date.' },
            { question: 'Is App Store and Google Play upload included?', answer: 'Yes, we manage the process of uploading and publishing your application to the App Store and Google Play.' }
          ]
        }
      },
      marketplace: {
        tag: 'Маркетплейс',
        title: 'Консалтинг маркетплейсов',
        description: 'Оптимизируйте стратегию продаж на маркетплейсах, таких как Trendyol и Amazon, и увеличьте прибыль.',
        features: [
          { title: 'Стратегия маркетплейсов', description: 'Выбор подходящей площадки и разработка стратегии продаж' },
          { title: 'Оптимизация товаров', description: 'Оптимизация листингов, названий и описаний товаров' },
          { title: 'Ценовая стратегия', description: 'Конкурентное ценообразование и планирование акций' },
          { title: 'Управление запасами', description: 'Учет запасов и оптимизация цепочки поставок' },
          { title: 'Обслуживание клиентов', description: 'Поддержка покупателей и управление отзывами на маркетплейсе' },
          { title: 'Анализ эффективности', description: 'Метрики продаж и отчетность' }
        ],
        keyBenefits: {
          title: 'Как мы развиваем ваш бизнес с консалтингом маркетплейсов',
          subtitle: 'Оптимизируйте стратегию продаж на маркетплейсах Trendyol, Amazon, Hepsiburada и увеличивайте продажи.',
          benefits: [
            { title: 'Стратегия маркетплейсов', description: 'Увеличивайте долю рынка за счет выбора подходящей площадки и разработки стратегии продаж. Добивайтесь успеха на Trendyol, Amazon, Hepsiburada.' },
            { title: 'Оптимизация товаров', description: 'Повышайте видимость и продажи за счет оптимизации листингов, названий, описаний и изображений товаров.' },
            { title: 'Управление эффективностью', description: 'Постоянно улучшайте результаты на маркетплейсе с помощью метрик продаж, управления запасами и обслуживания клиентов.' }
          ]
        },
        additionalFeatures: {
          title: 'Комплексные решения для маркетплейсов',
          subtitle: 'Мы предлагаем профессиональные консультации по всем вопросам работы с маркетплейсами.'
        },
        faq: {
          title: 'Часто задаваемые вопросы',
          subtitle: 'Наиболее частые вопросы о консалтинге маркетплейсов',
          items: [
            { question: 'На каких маркетплейсах вы работаете?', answer: 'Мы работаем со всеми крупными площадками: Trendyol, Amazon, Hepsiburada, GittiGidiyor, N11.' },
            { question: 'Как разрабатывается стратегия продаж на маркетплейсе?', answer: 'Мы разрабатываем комплексную стратегию в области анализа рынка, оптимизации товаров, ценовой стратегии, управления запасами и обслуживания клиентов.' },
            { question: 'Какие комиссии у маркетплейсов?', answer: 'Размер комиссии зависит от площадки. Обычно комиссия составляет 8–15%. Свяжитесь с нами для уточнения.' },
            { question: 'Как осуществляется управление запасами?', answer: 'Мы оптимизируем управление запасами с помощью учета, оптимизации цепочки поставок и автоматических уведомлений.' },
            { question: 'Что входит в отчеты по эффективности на маркетплейсе?', answer: 'В ежемесячных отчетах: тренды продаж, эффективность товаров, отзывы покупателей, состояние запасов и рекомендации по улучшению.' }
          ]
        }
      },
      mentorluk: {
        tag: 'Менторство',
        title: 'Менторство по цифровому маркетингу',
        description: 'Развивайте свои навыки цифрового маркетинга, оптимизируйте свои стратегии и выведите свой бизнес на следующий уровень с индивидуальными консультациями от наших опытных менторов.',
        features: [
          { title: 'Индивидуальные сессии менторства', description: 'Развивайте свои стратегии с индивидуальными встречами с нашими опытными менторами' },
          { title: 'Персонализированные стратегии', description: 'Создавайте стратегии и дорожные карты цифрового маркетинга, специфичные для вашего бизнеса' },
          { title: 'Постановка целей и отслеживание', description: 'Устанавливайте четкие цели и измеряйте свой прогресс с регулярным отслеживанием' },
          { title: 'Практическое обучение', description: 'Практика на реальных проектах в дополнение к теоретическим знаниям' },
          { title: 'Постоянная поддержка', description: 'Получайте мгновенные ответы на ваши вопросы и постоянное руководство на протяжении всего процесса менторства' },
          { title: 'Оптимизация производительности', description: 'Анализируйте и оптимизируйте ваши существующие кампании' }
        ],
        services: [
          'Менторство по Google Ads',
          'Разработка стратегий Meta Ads',
          'Руководство по оптимизации SEO',
          'Стратегии электронной коммерции',
          'Управление социальными сетями',
          'Планирование контент-маркетинга',
          'Оптимизация конверсий',
          'Аналитика и отчетность',
          'Консалтинг маркетплейсов',
          'Оптимизация Shopify'
        ],
        keyBenefits: {
          title: 'Как мы развиваем ваш бизнес с менторством',
          subtitle: 'Развивайте свои навыки цифрового маркетинга с экспертным руководством и выведите свой бизнес на следующий уровень.',
          benefits: [
            { title: 'Индивидуальное руководство', description: 'Развивайте свои стратегии с индивидуальными встречами с нашими опытными менторами. Достигайте своих целей с персонализированными дорожными картами.' },
            { title: 'Практический опыт', description: 'Получайте опыт, практикуясь на реальных проектах в дополнение к теоретическим знаниям. Анализируйте и оптимизируйте ваши существующие кампании.' },
            { title: 'Постоянная поддержка', description: 'Получайте мгновенные ответы на ваши вопросы и постоянное руководство на протяжении всего процесса менторства. Выведите свой бизнес на следующий уровень.' }
          ]
        },
        additionalFeatures: {
          title: 'Комплексные программы менторства',
          subtitle: 'Мы предлагаем экспертное руководство во всех областях цифрового маркетинга.'
        },
        faq: {
          title: 'Часто задаваемые вопросы',
          subtitle: 'Наиболее часто задаваемые вопросы о менторстве по цифровому маркетингу',
          items: [
            { question: 'Как работает программа менторства?', answer: 'Это комплексная программа, включающая индивидуальные встречи, персонализированные стратегии, постановку целей и отслеживание, практическое обучение и постоянную поддержку.' },
            { question: 'По каким темам я могу получить менторство?', answer: 'Мы предлагаем менторство во всех областях цифрового маркетинга, таких как Google Ads, Meta Ads, SEO, электронная коммерция, управление социальными сетями, контент-маркетинг, оптимизация конверсий и аналитика.' },
            { question: 'Сколько длятся сессии менторства?', answer: 'Продолжительность сессии варьируется в соответствии с вашими потребностями. Обычно рекомендуются сессии 1-2 часа. Можно организовать еженедельные или ежемесячные программы.' },
            { question: 'Онлайн или лично?', answer: 'Мы предлагаем как онлайн, так и личные сессии менторства. Вы можете выбрать наиболее подходящий метод в соответствии с вашими предпочтениями.' },
            { question: 'Сколько длится программа менторства?', answer: 'Продолжительность программы варьируется в соответствии с вашими целями и потребностями. Обычно рекомендуются программы 3-6 месяцев, но можно также организовать более короткие или более длительные программы.' }
          ]
        }
      },
      shopify: {
        tag: 'Shopify',
        title: 'Shopify E-commerce',
        description: 'Запустите свой интернет-магазин с Shopify и увеличивайте продажи. Профессиональная настройка, дизайн и оптимизация магазина.',
        features: [
          { title: 'Настройка магазина', description: 'Профессиональная настройка и конфигурация Shopify' },
          { title: 'Пользовательский дизайн', description: 'Брендированная тема и дизайн' },
          { title: 'Интеграция продуктов', description: 'Загрузка и оптимизация продуктов' },
          { title: 'Интеграция платежей', description: 'Безопасная интеграция платежной системы' },
          { title: 'Интеграция доставки', description: 'Интеграция компаний-перевозчиков и вариантов доставки' },
          { title: 'Оптимизация производительности', description: 'Скорость и оптимизация конверсии' }
        ],
        mockupCard: {
          managerName: 'Samed Ordueri',
          managerTitle: 'Консультант Shopify',
          title: 'Магазин Shopify',
          description: 'Запустите свой интернет-магазин профессионально.',
          details: {
            duration: '30 мин',
            timeSlots: ['15д', '30д', '45д', '1ч'],
            meeting: 'Google Meet',
            timezone: 'Europe/İstanbul'
          },
          stats: {
            roi: 'ROI',
            projects: 'Проекты',
            support: 'Поддержка'
          }
        },
        keyBenefits: {
          title: 'Как мы развиваем ваш бизнес с Shopify',
          subtitle: 'Запустите свой интернет-магазин профессионально, оптимизируйте продажи и развивайте свой бизнес.',
          benefits: [
            { title: 'Профессиональная настройка', description: 'Запустите свой интернет-магазин быстро с профессиональной настройкой и конфигурацией Shopify.' },
            { title: 'Пользовательский дизайн', description: 'Усиливайте свой бренд с пользовательской темой и дизайном. Увеличивайте конверсии с удобным для пользователя интерфейсом.' },
            { title: 'Оптимизация производительности', description: 'Увеличивайте продажи с оптимизацией скорости, безопасной платежной инфраструктурой и стратегиями SEO.' }
          ]
        },
        additionalFeatures: {
          title: 'Комплексные решения Shopify',
          subtitle: 'Мы предлагаем профессиональные услуги для всех ваших потребностей Shopify.'
        },
        faq: {
          title: 'Часто задаваемые вопросы',
          subtitle: 'Наиболее часто задаваемые вопросы о Shopify',
          items: [
            { question: 'Что такое Shopify?', answer: 'Shopify — это облачная платформа электронной коммерции, которая позволяет вам создать и управлять вашим интернет-магазином. Это идеальная платформа для предприятий любого размера.' },
            { question: 'Сколько стоит Shopify?', answer: 'Планы Shopify начинаются от $29/месяц. В зависимости от потребностей вашего бизнеса, доступны разные пакеты.' },
            { question: 'Сколько времени занимает процесс настройки магазина?', answer: 'Процесс настройки и запуска базового магазина занимает в среднем 2-4 недели. Для более сложных проектов это может занять больше времени.' },
            { question: 'Предоставляете ли вы обучение по Shopify?', answer: 'Да, мы предоставляем подробное обучение по использованию панели администратора Shopify, управлению продуктами и настройкам.' },
            { question: 'Предоставляете ли вы обслуживание магазина?', answer: 'Да, мы предлагаем услуги по обслуживанию, обновлениям и технической поддержке после запуска.' }
          ]
        }
      },
    },
    // Home Page
    home: {
      hero: {
        newRelease: 'Цифровая трансформация',
        title: 'Увеличьте ROI с экспертными цифровыми маркетинговыми решениями',
        description: 'Оптимизируем ваши рекламные кампании с помощью стратегий, основанных на данных. Увеличиваем прибыль с помощью Google Ads, Meta Ads и SEO.',
        contactButton: 'Связаться',
        exploreServices: 'Посмотреть услуги',
        messages: [
          { title: 'Увеличьте ROI с экспертными решениями по цифровому маркетингу', description: 'Оптимизируем ваши рекламные кампании с помощью стратегий, основанных на данных. Увеличиваем прибыль с помощью Google Ads, Meta Ads и SEO.' },
          { title: 'Управляйте кампаниями Google Ads как профессионал', description: 'Увеличьте продажи и снизьте расходы на рекламу с помощью наших профессиональных решений по управлению Google Ads. Оптимизируем ROAS.' },
          { title: 'Масштабируйте свой бренд с рекламой Meta Ads', description: 'Достигайте миллионов пользователей с помощью эффективных стратегий рекламы в Facebook и Instagram. Увеличивайте конверсии с точным таргетингом.' },
          { title: 'Оптимизируйте свой сайт для поисковых систем', description: 'Увеличьте органический трафик и занимайте верхние позиции с помощью наших услуг SEO. Станьте видимыми для ваших клиентов.' },
          { title: 'Продавайте больше с профессиональным веб-дизайном', description: 'Увеличивайте конверсии с современными, ориентированными на пользователя веб-сайтами. Повышайте удовлетворенность клиентов с дизайном UX/UI.' }
        ]
      },
      references: {
        title: 'Быстрорастущие бренды доверяют Thinklyze.'
      },
      servicesSection: {
        title: 'Наши услуги цифрового маркетинга',
        subtitle: 'Комплексные решения для укрепления вашего бренда в цифровой среде.'
      },
      services: {
        googleAds: {
          title: 'Google Реклама',
          description: 'Управление кампаниями Google Ads и YouTube',
          features: ['Управление кампаниями Google Ads', 'Оптимизация ключевых слов', 'Отслеживание ROI и отчеты'],
          price: '5.000₺+',
          duration: 'Ежемесячно',
          details: 'Подробнее',
        },
        metaAds: {
          title: 'Meta Реклама',
          description: 'Реклама в Facebook и Instagram',
          features: ['Реклама в Facebook и Instagram', 'Оптимизация целевой аудитории', 'Дизайн креативов и видео'],
          price: '5.000₺+',
          duration: 'Ежемесячно',
          details: 'Подробнее',
        },
        socialMedia: {
          title: 'Управление соцсетями',
          description: 'Управление социальными сетями и создание контента',
          features: ['Создание и планирование контента', 'Управление сообществом', 'Анализ вовлеченности'],
          price: '3.000₺+',
          duration: 'Ежемесячно',
          details: 'Подробнее',
        },
        webDesign: {
          title: 'Веб-дизайн',
          description: 'Современный и адаптивный веб-дизайн',
          features: ['Современный и адаптивный дизайн', 'SEO-оптимизация', 'Скорость и производительность'],
          price: '15.000₺+',
          duration: 'Проект',
          details: 'Подробнее',
        },
        seoGeo: {
          title: 'SEO & GEO',
          description: 'Оптимизация поисковых систем и локальное SEO',
          features: ['Исследование и анализ ключевых слов', 'Техническая SEO-оптимизация', 'Оптимизация Google Maps'],
          price: '4.000₺+',
          duration: 'Ежемесячно',
          details: 'Подробнее',
        },
        appDevelopment: {
          title: 'Разработка приложений',
          description: 'Разработка мобильных и веб-приложений',
          features: ['Разработка iOS и Android', 'API интеграции', 'Поддержка и обслуживание'],
          price: '25.000₺+',
          duration: 'Проект',
          details: 'Подробнее',
        },
        marketplace: {
          title: 'Консалтинг маркетплейсов',
          description: 'Оптимизируйте стратегию продаж на маркетплейсах, таких как Trendyol и Amazon, и увеличьте прибыль.',
          features: ['Стратегия маркетплейсов', 'Оптимизация карточек товаров', 'Отчетность и аналитика'],
          price: '4.000₺',
          duration: 'Ежемесячно',
          details: 'Подробнее',
        },
      },
      viewAllServices: 'Просмотреть все услуги',
      digitalExcellence: {
        teamBadge: '+15 экспертов в команде',
        title: 'Открываем новые горизонты в цифровом совершенстве',
        description: 'Присоединяйтесь к нашему путешествию по созданию веб-страниц с идеальными деталями.',
        cta: 'Изучить возможности',
        stats: {
          conversion: 'Рост конверсии',
          customers: 'Довольных клиентов'
        },
        features: [
          { title: 'Pixel-Perfect', description: 'Начните путь создания веб-сайтов с идеальными деталями.' },
          { title: 'Супер контроль', description: 'Начните путь проектирования безупречных веб-страниц.' },
          { title: 'Онлайн доступ', description: 'Продвигайте свой бизнес, привлекая новых клиентов на различных платформах.' },
          { title: 'Простота использования', description: 'Продвигайте свой бизнес, привлекая клиентов на нескольких платформах.' },
          { title: 'Продвинутые инструменты', description: 'Развивайте свой бизнес с профессиональными инструментами цифрового маркетинга.' },
          { title: 'Поддержка 7/24', description: 'Получайте постоянную поддержку и консультации от нашей команды экспертов.' }
        ]
      },
      advancedFeatures: {
        badge: 'Мощные возможности',
        title: 'Захватите будущее с вашим веб-сайтом',
        subtitle: 'Продвигайте свой бизнес, привлекая клиентов на платформах.',
        sectionBadge: 'Расширенные возможности',
        sectionTitle: 'Сделайте свой веб-сайт настоящим лидером отрасли.',
        sectionDescription: 'Откройте новые границы веб-дизайна с инструментами, которые позволяют создавать визуально впечатляющие и технически надежные цифровые решения.',
        cta: 'Услуги веб-дизайна',
        viewAllWebsites: 'Посмотреть все сайты из портфолио'
      },
      marketingTools: {
        badge: 'Калькуляторы',
        title: 'Маркетинговые расчетные инструменты',
        description: 'Профессиональные калькуляторы для рекламодателей. Оптимизируйте кампании с помощью ROAS, ROI, CPM и других метрик.',
        cta: 'Просмотреть все калькуляторы',
        moreToolsLabel: 'Еще +{count} инструментов',
        categories: [
          {
            id: 'roas-roi',
            name: 'ROAS & ROI',
            description: 'Аналитика эффективности рекламы и инвестиций',
            tools: ['Экономика электронной коммерции', 'Калькулятор ROAS', 'Калькулятор ROI', 'Калькулятор CPM'],
          },
          {
            id: 'influencer',
            name: 'Influencer Marketing',
            description: 'Метрики кампаний с инфлюенсерами',
            tools: ['Показатель вовлеченности', 'Influencer CPM'],
          },
          {
            id: 'budget',
            name: 'Планирование бюджета',
            description: 'Оптимизация бюджетов кампаний',
            tools: ['Дневной бюджет', 'Распределение бюджета', 'Разделение по платформам', 'Бюджет с целью ROI'],
          },
          {
            id: 'social',
            name: 'Социальные сети',
            description: 'Метрики эффективности соцсетей',
            tools: ['Показатель вовлеченности', 'CTR (кликабельность)'],
          },
          {
            id: 'ecommerce',
            name: 'E-commerce KPI',
            description: 'Показатели эффективности электронной коммерции',
            tools: ['Калькулятор LTV', 'Калькулятор CAC', 'Соотношение LTV/CAC'],
          },
          {
            id: 'content',
            name: 'Аналитика контента',
            description: 'Измерение эффективности контента',
            tools: ['ROI контента', 'Коэффициент конверсии'],
          },
        ],
      },
    },
    // About Page
    about: {
      badge: 'О нас',
      title: 'О нас',
      subtitle: 'С 2019 года мы - команда, которая развивает бренды и создает результативные решения в области цифрового маркетинга.',
      storyTitle: 'Наша история',
      storyParagraphs: [
        'Thinklyze была основана в 2019 году с видением раскрытия потенциала брендов в цифровом мире. 10+ летний опыт нашей команды основателей и страсть к цифровому маркетингу формируют основу того, где мы находимся сегодня.',
        'Мы начали как небольшая команда, но быстро выросли благодаря нашему фокусу на успехе клиентов и достигнутым результатам. Каждый проект для нас - это новая возможность обучения и шаг на пути к совершенству.',
        'Сегодня, с нашими 150+ довольными клиентами, мы продолжаем быть надежным партнером в области цифрового маркетинга, сопровождая бренды на их пути роста.'
      ],
      stats: {
        customers: 'Довольных клиентов',
        projects: 'Завершенных проектов',
        experience: 'Лет опыта',
        roi: 'Средний рост ROI'
      },
      valuesTitle: 'Наши ценности',
      valuesSubtitle: 'Основные ценности, которые формируют наш подход к работе',
      values: [
        { title: 'Ориентация на результат', description: 'Мы работаем для достижения измеримых результатов в каждом проекте.' },
        { title: 'Удовлетворенность клиентов', description: 'Успех наших клиентов - наша главная мотивация.' },
        { title: 'Инновационный подход', description: 'Мы команда, которая постоянно учится и создает инновационные решения.' },
        { title: 'Надежность', description: 'Мы строим доверие с прозрачной коммуникацией и честным подходом.' }
      ],
      missionTitle: 'Наша миссия',
      missionSubtitle: 'Писать истории успеха брендов в цифровом мире',
      mission: {
        badge: 'Наше видение',
        title: 'Пионер цифровой трансформации',
        description: 'Быть самым надежным и инновационным агентством Турции в области цифрового маркетинга и performance рекламы. Добавлять ценность нашим клиентам с помощью стратегий, основанных на данных, и измеримых результатов.',
        features: [
          'Разрабатывать стратегии на основе данных',
          'Обеспечивать измеримые результаты',
          'Быть командой, которая постоянно учится и развивается',
          'Приоритизировать успех клиентов'
        ]
      },
      milestones: [
        { year: '2019', title: 'Основание', description: 'Thinklyze начала предоставлять услуги в области цифрового маркетинга.' },
        { year: '2020', title: '50+ клиентов', description: 'В первый год мы обслужили более 50 клиентов.' },
        { year: '2021', title: 'Расширение команды', description: 'Мы расширили нашу команду экспертов и повысили качество обслуживания.' },
        { year: '2022', title: '100+ проектов', description: 'Мы завершили более 100 успешных проектов.' },
        { year: '2023', title: 'Награда', description: 'Мы получили награду "Лучшее агентство цифрового маркетинга".' },
        { year: '2024', title: 'Рост', description: 'Мы продолжаем расти с 150+ активными клиентами.' }
      ]
    },
    // Academy Page
    academy: {
      badge: 'Академия',
      title: 'Академия цифрового маркетинга',
      subtitle: 'Развивайтесь в области цифрового маркетинга. Достигайте экспертного уровня с нашими видеоуроками.',
      videosSection: {
        badge: 'Наши видеоуроки',
        title: 'Изучайте цифровой маркетинг',
        description: 'Развивайте свои навыки цифрового маркетинга с интерактивными видеоуроками, подготовленными нашей командой экспертов.'
      }
    },
    // Marketing Tools Page
    marketingTools: {
      badge: 'Калькуляторы',
      title: 'Маркетинговые расчетные инструменты',
      subtitle: 'Профессиональные инструменты расчета для оптимизации ваших рекламных кампаний. Легко рассчитывайте ROAS, ROI, CPM и многое другое.',
      selectCategory: 'Выбрать категорию',
      ecommerceCalculator: {
        title: 'Калькулятор экономики электронной коммерции',
        description: 'Анализируйте рентабельность вашего бизнеса электронной коммерции',
        inputs: {
          unitPrice: 'Цена продажи товара (₺)',
          unitCost: 'Себестоимость проданного товара - COGS (₺)',
          vatRate: 'Ставка НДС (%)',
          vatIncludedPrice: 'Цена с НДС (₺)',
          wholesaleDepot: 'Оптовая закупка + Поступление на склад (₺)',
          marketplaceCommission: 'Процент комиссии (%)',
          marketplaceCommissionAmount: 'Сумма комиссии',
          paymentInfraCommission: 'Комиссия платежной инфраструктуры (%)',
          paymentInfraCommissionPlaceholder: 'Paytr, İyzico и т.д. Например 3.75',
          paymentInfraCost: 'Стоимость платежной инфраструктуры (₺)',
          packagingCost: 'Стоимость упаковки (₺)',
          shippingCost: 'Стоимость доставки (₺)',
          returnRate: 'Процент возвратов (%)',
          returnRateCost: 'Стоимость возвратов (₺)',
          codExpenses: 'Общие расходы COD (₺)',
          cacTarget: 'Целевой CAC (₺)',
          netProfitTarget: 'Целевая чистая прибыль (₺)',
          adSpend: 'Расходы на рекламу (₺)',
          totalOrders: 'Общее количество заказов'
        },
        outputs: {
          revenue: 'Общий доход (₺)',
          totalCosts: 'Общие расходы (₺)',
          grossProfit: 'Валовая прибыль (₺)',
          netProfit: 'Чистая прибыль (₺)',
          cac: 'Стоимость привлечения клиента (CAC)',
          roas: 'ROAS',
          roasLabel: 'Минимальная цель 2.5',
          roi: 'ROI (%)',
          breakEvenRoas: 'Точка безубыточности ROAS',
          profitMargin: 'Маржа прибыли (%)',
          avgOrderCount: 'Среднее количество заказов клиента',
          avgBasket: 'Средняя корзина (₺)',
          ltv: 'LTV (₺)',
          ltvCacRatio: 'Соотношение LTV / CAC',
          netProfitPercent: 'Чистая прибыль % (%)',
          grossProfitPercent: 'Валовая прибыль % (%)',
          cacFormula: 'Валовая прибыль - Чистая прибыль',
          roasFormula: 'Доход / CAC',
          roiFormula: 'Точка безубыточности',
          breakEvenFormula: 'Не может быть рассчитано',
          breakEvenDescription: 'ниже убыток, выше прибыль',
          revenueCacDescription: 'Доход: {revenue} ₺ / CAC: {cac} ₺'
        },
        vatNote: {
          title: 'Примечание по НДС:',
          text: 'НДС, как налог, взимаемый от имени государства: • Это не прибыль бизнеса. • Он не включается в анализ рентабельности, затраты и расчеты ROAS.'
        },
        tabs: {
          ecommerceEconomics: 'Экономика электронной коммерции',
          roasCalculator: 'Калькулятор ROAS',
          roiCalculator: 'Калькулятор ROI',
          cpmCalculator: 'Калькулятор CPM'
        },
        warning: 'Примечание: В расчетах изменены только зеленые поля и ставка НДС.',
        videoTitle: 'Как рассчитать?',
        videoDescription: 'Мы подробно объяснили, как производятся расчеты экономики электронной коммерции, в нашем видео.'
      },
      buttons: {
        downloadPDF: 'Скачать PDF отчет',
        shareResult: 'Поделиться результатом'
      },
      faq: {
        title: 'Часто задаваемые вопросы',
        subtitle: 'Ответы на ваши вопросы о калькуляторе экономики электронной коммерции',
        items: [
          {
            question: 'Что такое ROI и ROAS? В чем разница между ними?',
            answer: 'ROI (Return on Investment) - это коэффициент возврата инвестиций и включает все затраты. ROAS (Return on Ad Spend) включает только расходы на рекламу. ROI выражается в процентах (например, 250%), а ROAS выражается как соотношение (например, 4:1). Для получения подробной информации вы можете прочитать наше <a href=\'/blog/roi-nedir-nasil-hesaplanir-2025-rehberi\' class=\'text-blue-600 hover:text-blue-800 underline\'>руководство по ROI</a> и <a href=\'/blog/roas-nedir-nasil-hesaplanir-reklam-verimliligi-rehberi\' class=\'text-blue-600 hover:text-blue-800 underline\'>руководство по ROAS</a>.'
          },
          {
            question: 'Каким должно быть значение ROAS?',
            answer: 'Значение ROAS варьируется в зависимости от отрасли и маржи прибыли продукта. Как правило, для предприятий электронной коммерции целевые значения ROAS составляют 4:1 или выше. Однако, если маржа прибыли продукта низкая, может потребоваться более высокий ROAS. Точка безубыточности составляет 1:1, то есть она должна быть выше этого значения.'
          },
          {
            question: 'Как рассчитывается CAC (стоимость привлечения клиента)?',
            answer: 'В этом калькуляторе CAC автоматически рассчитывается по формуле Валовая прибыль - Чистая прибыль. CAC - это общая стоимость, потраченная на привлечение клиента. Чем ниже значение CAC, тем прибыльнее бизнес.'
          },
          {
            question: 'Что такое LTV (пожизненная ценность)? Как она рассчитывается?',
            answer: 'LTV - это общий доход, который клиент приносит бизнесу в течение всей жизни. В этом калькуляторе LTV рассчитывается по формуле Средняя корзина × Среднее количество заказов клиента. Рекомендуется соотношение LTV/CAC 3:1 или выше.'
          },
          {
            question: 'Почему НДС не включен в расчеты?',
            answer: 'НДС - это налог, взимаемый от имени государства, поэтому это не прибыль бизнеса. Поэтому он не включается в анализ рентабельности, затраты и расчеты ROAS. Калькулятор показывает цену продажи с НДС, но НДС исключается из расчетов прибыли.'
          },
          {
            question: 'Как скачать PDF отчет?',
            answer: 'Нажмите кнопку \'Скачать PDF отчет\', чтобы скачать результаты расчетов в формате PDF. PDF включает логотип, дату, все результаты расчетов и номера страниц. Вы также можете использовать кнопку \'Поделиться результатом\', чтобы поделиться PDF.'
          },
          {
            question: 'Как я могу поделиться результатами расчетов?',
            answer: 'Нажмите кнопку \'Поделиться результатом\', чтобы поделиться результатами расчетов. Эта кнопка позволяет поделиться PDF отчетом или скопировать результаты в виде текста. Если поддерживается Web Share API, вы можете поделиться им как PDF файлом.'
          },
          {
            question: 'Какие поля можно изменить?',
            answer: 'В калькуляторе можно изменить только зеленые поля и ставку НДС. Желтые поля - это автоматически рассчитанные результаты, и их нельзя изменить. Значение CAC также автоматически рассчитывается (Валовая прибыль - Чистая прибыль) и не может быть изменено.'
          },
          {
            question: 'Что такое точка безубыточности ROAS?',
            answer: 'Точка безубыточности ROAS - это точка, где прибыль равна нулю. При этом значении ROAS вы не получаете ни прибыли, ни убытков. Значение точки безубыточности ROAS - это точка, где общие затраты равны доходу. Вам нужно достичь ROAS выше этого значения.'
          },
          {
            question: 'Какие метрики рассчитывает этот калькулятор?',
            answer: 'Этот калькулятор рассчитывает ROI, ROAS, LTV, CAC, валовую прибыль, чистую прибыль, точку безубыточности ROAS и проценты прибыли. Он также учитывает комиссию, стоимость платежной инфраструктуры, доставку, упаковку и затраты на возврат.'
          }
        ]
      }
    },
    // References Page
    references: {
      title: 'Наши референции',
      subtitle: 'Бренды, с которыми мы работаем, и наши истории успеха',
      categories: {
        all: 'Все',
        shoeBag: 'Обувь и сумки',
        babyKids: 'Дети и младенцы',
        homeFurniture: 'Дом и мебель',
        food: 'Еда',
        service: 'Услуги',
        personalCare: 'Личный уход',
        automotive: 'Автомобили',
        outdoor: 'Отдых на природе',
        marketplace: 'Маркетплейс',
        healthMedical: 'Здоровье и медицина',
        jewelry: 'Ювелирные изделия',
        textile: 'Текстиль и скромная мода',
        electronics: 'Электроника'
      }
    },
    // Testimonials
    testimonials: {
      tag: 'Отзывы клиентов',
      title: 'Что говорят наши клиенты',
      subtitle: 'Узнайте, почему наши клиенты предпочитают нас. Откройте для себя, как мы способствуем их успеху в цифровом маркетинге.',
      items: [
        {
          quote: 'Работа с Thinklyze полностью изменила наш бизнес. Благодаря управлению кампаниями Google Ads наш ROI увеличился на 400%. Подход, основанный на данных, и профессиональный результат.',
          name: 'Ахмет Йылмаз',
          title: 'CEO, TechStart',
          avatar: 'AY'
        },
        {
          quote: 'Наш магазин электронной коммерции значительно вырос благодаря услугам, которые мы получили от Thinklyze. Наш ROI увеличился на 300%, и наша клиентская база расширилась. Наши кампании Google Ads были полностью оптимизированы.',
          name: 'Зейнеп Демир',
          title: 'Основатель, Moda E-Ticaret',
          avatar: 'ZD'
        },
        {
          quote: 'Наши кампании Meta Ads достигли идеальной производительности с Thinklyze. Мы охватили правильную аудиторию и значительно увеличили конверсии. Мы очень довольны их стратегическим подходом.',
          name: 'Мурат Кая',
          title: 'Директор по маркетингу, FashionHub',
          avatar: 'MK'
        },
        {
          quote: 'Наши стратегии социальных сетей стали намного более эффективными с Thinklyze. Вовлеченность нашего сообщества увеличилась, наша узнаваемость бренда значительно выросла. Контент-маркетинг на высшем уровне.',
          name: 'Айше Йылдыз',
          title: 'Основатель, BeautyBox',
          avatar: 'AY'
        },
        {
          quote: 'Наш новый веб-сайт, разработанный Thinklyze, великолепен. Скорость, дизайн UX/UI и показатели конверсии идеальны. Наше присутствие в цифровом мире значительно укрепилось.',
          name: 'Can Озтюрк',
          title: 'Генеральный директор, DigitalCorp',
          avatar: 'CO'
        },
        {
          quote: 'Работать с Thinklyze - значит работать с настоящими профессионалами. Управление Google Ads на высшем уровне, постоянные отчеты, прозрачные процессы. Я чувствую себя в безопасности.',
          name: 'Эмине Коч',
          title: 'Владелец, HomeDecor',
          avatar: 'EK'
        },
        {
          quote: 'Наша консультация по электронной коммерции полностью изменила наш процесс продаж. Оптимизация процесса оформления заказа, персонализация и стратегии email-маркетинга привели к значительному увеличению продаж.',
          name: 'Али Челик',
          title: 'Основатель, TechMart',
          avatar: 'AC'
        },
        {
          quote: 'Наш магазин Shopify был настроен и оптимизирован Thinklyze идеально. Производительность магазина отличная, интеграция с платежами работает без проблем. Рост продаж выше наших ожиданий.',
          name: 'Фатма Сахин',
          title: 'Владелец, OrganicShop',
          avatar: 'FS'
        },
        {
          quote: 'Наши кампании UGC и influencer marketing были очень успешными благодаря Thinklyze. Узнаваемость нашего бренда достигла широкой аудитории, и доверие клиентов возросло.',
          name: 'Бурак Челик',
          title: 'Основатель, BeautyBrand',
          avatar: 'BC'
        },
        {
          quote: 'Наш проект по дизайну и разработке веб-сайта был отлично управляем Thinklyze. Мы получили современный, быстрый и ориентированный на конверсию сайт. Удовлетворенность клиентов возросла.',
          name: 'Дениз Кая',
          title: 'CEO, ServiceCo',
          avatar: 'DK'
        },
        {
          quote: 'Мы работали с Thinklyze над нашим проектом разработки приложения. Наши приложения для iOS и Android были доставлены вовремя и качественно. API интеграции работают отлично.',
          name: 'Гёкхан Айдын',
          title: 'CTO, TechSolutions',
          avatar: 'GA'
        },
        {
          quote: 'Благодаря услугам SEO и GEO мы заняли верхние позиции в Google. С локальными SEO стратегиями количество клиентов, приходящих в наш физический магазин, значительно увеличилось.',
          name: 'Селин Йылмаз',
          title: 'Директор по маркетингу, LocalBusiness',
          avatar: 'SY'
        }
      ]
    },
  },
}

export default translations














